// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-balham {
  -webkit-font-smoothing: antialiased;
  color: #000;
  color: var(--ag-foreground-color, #000);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 12px;
  line-height: normal;
}
@font-face {
  font-family: "agGridBalham";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.ag-theme-balham .ag-icon {
  font-family: "agGridBalham";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ag-theme-balham .ag-icon-aggregation::before {
  content: "\\f101";
}
.ag-theme-balham .ag-icon-arrows::before {
  content: "\\f102";
}
.ag-theme-balham .ag-icon-asc::before {
  content: "\\f103";
}
.ag-theme-balham .ag-icon-cancel::before {
  content: "\\f104";
}
.ag-theme-balham .ag-icon-chart::before {
  content: "\\f105";
}
.ag-theme-balham .ag-icon-color-picker::before {
  content: "\\f109";
}
.ag-theme-balham .ag-icon-columns::before {
  content: "\\f10a";
}
.ag-theme-balham .ag-icon-contracted::before {
  content: "\\f10b";
}
.ag-theme-balham .ag-icon-copy::before {
  content: "\\f10c";
}
.ag-theme-balham .ag-icon-cross::before {
  content: "\\f10d";
}
.ag-theme-balham .ag-icon-csv::before {
  content: "\\f10e";
}
.ag-theme-balham .ag-icon-desc::before {
  content: "\\f10f";
}
.ag-theme-balham .ag-icon-excel::before {
  content: "\\f110";
}
.ag-theme-balham .ag-icon-expanded::before {
  content: "\\f111";
}
.ag-theme-balham .ag-icon-eye-slash::before {
  content: "\\f112";
}
.ag-theme-balham .ag-icon-eye::before {
  content: "\\f113";
}
.ag-theme-balham .ag-icon-filter::before {
  content: "\\f114";
}
.ag-theme-balham .ag-icon-first::before {
  content: "\\f115";
}
.ag-theme-balham .ag-icon-grip::before {
  content: "\\f116";
}
.ag-theme-balham .ag-icon-group::before {
  content: "\\f117";
}
.ag-theme-balham .ag-icon-last::before {
  content: "\\f118";
}
.ag-theme-balham .ag-icon-left::before {
  content: "\\f119";
}
.ag-theme-balham .ag-icon-linked::before {
  content: "\\f11a";
}
.ag-theme-balham .ag-icon-loading::before {
  content: "\\f11b";
}
.ag-theme-balham .ag-icon-maximize::before {
  content: "\\f11c";
}
.ag-theme-balham .ag-icon-menu::before {
  content: "\\f11d";
}
.ag-theme-balham .ag-icon-minimize::before {
  content: "\\f11e";
}
.ag-theme-balham .ag-icon-next::before {
  content: "\\f11f";
}
.ag-theme-balham .ag-icon-none::before {
  content: "\\f120";
}
.ag-theme-balham .ag-icon-not-allowed::before {
  content: "\\f121";
}
.ag-theme-balham .ag-icon-paste::before {
  content: "\\f122";
}
.ag-theme-balham .ag-icon-pin::before {
  content: "\\f123";
}
.ag-theme-balham .ag-icon-pivot::before {
  content: "\\f124";
}
.ag-theme-balham .ag-icon-previous::before {
  content: "\\f125";
}
.ag-theme-balham .ag-icon-right::before {
  content: "\\f128";
}
.ag-theme-balham .ag-icon-save::before {
  content: "\\f129";
}
.ag-theme-balham .ag-icon-small-down::before {
  content: "\\f12a";
}
.ag-theme-balham .ag-icon-small-left::before {
  content: "\\f12b";
}
.ag-theme-balham .ag-icon-small-right::before {
  content: "\\f12c";
}
.ag-theme-balham .ag-icon-small-up::before {
  content: "\\f12d";
}
.ag-theme-balham .ag-icon-tick::before {
  content: "\\f12e";
}
.ag-theme-balham .ag-icon-tree-closed::before {
  content: "\\f12f";
}
.ag-theme-balham .ag-icon-tree-indeterminate::before {
  content: "\\f130";
}
.ag-theme-balham .ag-icon-tree-open::before {
  content: "\\f131";
}
.ag-theme-balham .ag-icon-unlinked::before {
  content: "\\f132";
}
.ag-theme-balham .ag-icon-row-drag::before {
  content: "\\f116";
}
.ag-theme-balham .ag-left-arrow::before {
  content: "\\f119";
}
.ag-theme-balham .ag-right-arrow::before {
  content: "\\f128";
}
.ag-theme-balham .ag-root-wrapper {
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham [class^=ag-], .ag-theme-balham [class^=ag-]:focus, .ag-theme-balham [class^=ag-]:after, .ag-theme-balham [class^=ag-]:before {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  outline: none;
}
.ag-theme-balham [class^=ag-]::-ms-clear {
  display: none;
}
.ag-theme-balham .ag-checkbox .ag-input-wrapper,
.ag-theme-balham .ag-radio-button .ag-input-wrapper {
  overflow: visible;
}
.ag-theme-balham .ag-range-field .ag-input-wrapper {
  height: 100%;
}
.ag-theme-balham .ag-toggle-button {
  -webkit-box-flex: 0;
          flex: none;
  width: unset;
  min-width: unset;
}
.ag-theme-balham .ag-ltr .ag-label-align-right .ag-label {
  margin-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-label-align-right .ag-label {
  margin-right: 4px;
}

.ag-theme-balham input[class^=ag-] {
  margin: 0;
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham textarea[class^=ag-],
.ag-theme-balham select[class^=ag-] {
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham input[class^=ag-]:not([type]),
.ag-theme-balham input[class^=ag-][type=text],
.ag-theme-balham input[class^=ag-][type=number],
.ag-theme-balham input[class^=ag-][type=tel],
.ag-theme-balham input[class^=ag-][type=date],
.ag-theme-balham input[class^=ag-][type=datetime-local],
.ag-theme-balham textarea[class^=ag-] {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  border-width: 1px;
  border-style: solid;
  border-color: #95a5a6;
  border-color: var(--ag-input-border-color, #95a5a6);
}
.ag-theme-balham input[class^=ag-]:not([type]):disabled,
.ag-theme-balham input[class^=ag-][type=text]:disabled,
.ag-theme-balham input[class^=ag-][type=number]:disabled,
.ag-theme-balham input[class^=ag-][type=tel]:disabled,
.ag-theme-balham input[class^=ag-][type=date]:disabled,
.ag-theme-balham input[class^=ag-][type=datetime-local]:disabled,
.ag-theme-balham textarea[class^=ag-]:disabled {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  background-color: #ebebeb;
  background-color: var(--ag-input-disabled-background-color, #ebebeb);
  border-color: rgba(149, 165, 166, 0.3);
  border-color: var(--ag-input-disabled-border-color, rgba(149, 165, 166, 0.3));
}
.ag-theme-balham input[class^=ag-]:not([type]):focus,
.ag-theme-balham input[class^=ag-][type=text]:focus,
.ag-theme-balham input[class^=ag-][type=number]:focus,
.ag-theme-balham input[class^=ag-][type=tel]:focus,
.ag-theme-balham input[class^=ag-][type=date]:focus,
.ag-theme-balham input[class^=ag-][type=datetime-local]:focus,
.ag-theme-balham textarea[class^=ag-]:focus {
  outline: none;
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham input[class^=ag-]:not([type]):invalid,
.ag-theme-balham input[class^=ag-][type=text]:invalid,
.ag-theme-balham input[class^=ag-][type=number]:invalid,
.ag-theme-balham input[class^=ag-][type=tel]:invalid,
.ag-theme-balham input[class^=ag-][type=date]:invalid,
.ag-theme-balham input[class^=ag-][type=datetime-local]:invalid,
.ag-theme-balham textarea[class^=ag-]:invalid {
  border-width: 2px;
  border-style: solid;
  border-color: #e02525;
  border-color: var(--ag-input-border-color-invalid, var(--ag-invalid-color, #e02525));
}
.ag-theme-balham input[class^=ag-][type=number] {
  -moz-appearance: textfield;
}
.ag-theme-balham input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-balham input[class^=ag-][type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ag-theme-balham input[class^=ag-][type=range] {
  padding: 0;
}
.ag-theme-balham input[class^=ag-][type=button]:focus, .ag-theme-balham button[class^=ag-]:focus {
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
}
.ag-theme-balham .ag-drag-handle {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-list-item, .ag-theme-balham .ag-virtual-list-item {
  height: 24px;
}
.ag-theme-balham .ag-keyboard-focus .ag-virtual-list-item:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-select-list {
  background-color: white;
  background-color: var(--ag-background-color, white);
  overflow-y: auto;
  overflow-x: hidden;
}
.ag-theme-balham .ag-list-item {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-balham .ag-list-item.ag-active-item {
  background-color: #ecf0f1;
  background-color: var(--ag-row-hover-color, #ecf0f1);
}
.ag-theme-balham .ag-select-list-item {
  padding-left: 4px;
  padding-right: 4px;
  cursor: default;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.ag-theme-balham .ag-select-list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ag-theme-balham .ag-select .ag-picker-field-wrapper {
  background-color: white;
  background-color: var(--ag-background-color, white);
  min-height: 24px;
  cursor: default;
}
.ag-theme-balham .ag-select.ag-disabled .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-balham .ag-select:not(.ag-cell-editor) {
  height: 24px;
}
.ag-theme-balham .ag-select .ag-picker-field-display {
  margin: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-balham .ag-select .ag-picker-field-icon {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-balham .ag-select.ag-disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-rich-select {
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
}
.ag-theme-balham .ag-rich-select-list {
  width: 100%;
  min-width: 200px;
  height: 182px;
}
.ag-theme-balham .ag-rich-select-value {
  padding: 0 4px 0 12px;
  height: 28px;
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-rich-select-virtual-list-item {
  cursor: default;
  height: 24px;
}
.ag-theme-balham .ag-rich-select-virtual-list-item:hover {
  background-color: #ecf0f1;
  background-color: var(--ag-row-hover-color, #ecf0f1);
}
.ag-theme-balham .ag-rich-select-row {
  padding-left: 12px;
}
.ag-theme-balham .ag-rich-select-row-selected {
  background-color: #b7e4ff;
  background-color: var(--ag-selected-row-background-color, #b7e4ff);
}
.ag-theme-balham .ag-row-drag,
.ag-theme-balham .ag-selection-checkbox,
.ag-theme-balham .ag-group-expanded,
.ag-theme-balham .ag-group-contracted {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-ltr .ag-row-drag, .ag-theme-balham .ag-ltr .ag-selection-checkbox, .ag-theme-balham .ag-ltr .ag-group-expanded, .ag-theme-balham .ag-ltr .ag-group-contracted {
  margin-right: 12px;
}

.ag-theme-balham .ag-rtl .ag-row-drag, .ag-theme-balham .ag-rtl .ag-selection-checkbox, .ag-theme-balham .ag-rtl .ag-group-expanded, .ag-theme-balham .ag-rtl .ag-group-contracted {
  margin-left: 12px;
}

.ag-theme-balham .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  height: min(var(--ag-line-height, 26px), 26px);
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-balham .ag-group-expanded,
.ag-theme-balham .ag-group-contracted {
  cursor: pointer;
}
.ag-theme-balham .ag-group-title-bar-icon {
  cursor: pointer;
  -webkit-box-flex: 0;
          flex: none;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-ltr .ag-group-child-count {
  margin-left: 2px;
}

.ag-theme-balham .ag-rtl .ag-group-child-count {
  margin-right: 2px;
}

.ag-theme-balham .ag-group-title-bar {
  background-color: #e2e9eb;
  background-color: var(--ag-subheader-background-color, #e2e9eb);
  padding: 4px;
}
.ag-theme-balham .ag-group-toolbar {
  padding: 4px;
}
.ag-theme-balham .ag-disabled-group-title-bar, .ag-theme-balham .ag-disabled-group-container {
  opacity: 0.5;
}
.ag-theme-balham .group-item {
  margin: 2px 0;
}
.ag-theme-balham .ag-label {
  white-space: nowrap;
}
.ag-theme-balham .ag-ltr .ag-label {
  margin-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-label {
  margin-left: 4px;
}

.ag-theme-balham .ag-label-align-top .ag-label {
  margin-bottom: 2px;
}
.ag-theme-balham .ag-ltr .ag-slider-field, .ag-theme-balham .ag-ltr .ag-angle-select-field {
  margin-right: 8px;
}

.ag-theme-balham .ag-rtl .ag-slider-field, .ag-theme-balham .ag-rtl .ag-angle-select-field {
  margin-left: 8px;
}

.ag-theme-balham .ag-angle-select-parent-circle {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham .ag-angle-select-child-circle {
  top: 4px;
  left: 12px;
  width: 6px;
  height: 6px;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.54);
  background-color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-picker-field-wrapper {
  border: 1px solid;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  border-radius: 5px;
}
.ag-theme-balham .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
}
.ag-theme-balham .ag-picker-field-button {
  background-color: white;
  background-color: var(--ag-background-color, white);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-dialog.ag-color-dialog {
  border-radius: 5px;
}
.ag-theme-balham .ag-color-picker .ag-picker-field-display {
  height: 16px;
}
.ag-theme-balham .ag-color-panel {
  padding: 4px;
}
.ag-theme-balham .ag-spectrum-color {
  background-color: rgb(255, 0, 0);
  border-radius: 2px;
}
.ag-theme-balham .ag-spectrum-tools {
  padding: 10px;
}
.ag-theme-balham .ag-spectrum-sat {
  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));
}
.ag-theme-balham .ag-spectrum-val {
  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));
}
.ag-theme-balham .ag-spectrum-dragger {
  border-radius: 12px;
  height: 12px;
  width: 12px;
  border: 1px solid white;
  background: black;
  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
}
.ag-theme-balham .ag-spectrum-hue-background {
  border-radius: 2px;
}
.ag-theme-balham .ag-spectrum-alpha-background {
  border-radius: 2px;
}
.ag-theme-balham .ag-spectrum-tool {
  margin-bottom: 10px;
  height: 11px;
  border-radius: 2px;
}
.ag-theme-balham .ag-spectrum-slider {
  margin-top: -12px;
  width: 13px;
  height: 13px;
  border-radius: 13px;
  background-color: rgb(248, 248, 248);
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.ag-theme-balham .ag-recent-color {
  margin: 0 3px;
}
.ag-theme-balham .ag-recent-color:first-child {
  margin-left: 0;
}
.ag-theme-balham .ag-recent-color:last-child {
  margin-right: 0;
}
.ag-theme-balham.ag-dnd-ghost {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 32px !important;
  line-height: 32px;
  margin: 0;
  padding: 0 8px;
  -webkit-transform: translateY(8px);
          transform: translateY(8px);
}
.ag-theme-balham .ag-dnd-ghost-icon {
  margin-right: 4px;
  color: #000;
  color: var(--ag-foreground-color, #000);
}
.ag-theme-balham .ag-popup-child:not(.ag-tooltip-custom) {
  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
}
.ag-dragging-range-handle .ag-theme-balham .ag-dialog, .ag-dragging-fill-handle .ag-theme-balham .ag-dialog {
  opacity: 0.7;
  pointer-events: none;
}
.ag-theme-balham .ag-dialog {
  border-radius: 2px;
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-panel {
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham .ag-panel-title-bar {
  background-color: #f5f7f7;
  background-color: var(--ag-header-background-color, #f5f7f7);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
  height: 32px;
  padding: 4px 12px;
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-panel-title-bar-button {
  margin-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-panel-title-bar-button {
  margin-right: 4px;
}

.ag-theme-balham .ag-tooltip {
  background-color: #f5f7f7;
  background-color: var(--ag-header-background-color, #f5f7f7);
  color: #000;
  color: var(--ag-foreground-color, #000);
  padding: 4px;
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  border-radius: 2px;
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
  white-space: normal;
}
.ag-theme-balham .ag-tooltip.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-balham .ag-tooltip-custom {
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
}
.ag-theme-balham .ag-tooltip-custom.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-balham .ag-ltr .ag-column-select-indent-1 {
  padding-left: 20px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-1 {
  padding-right: 20px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-2 {
  padding-left: 40px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-2 {
  padding-right: 40px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-3 {
  padding-left: 60px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-3 {
  padding-right: 60px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-4 {
  padding-left: 80px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-4 {
  padding-right: 80px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-5 {
  padding-left: 100px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-5 {
  padding-right: 100px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-6 {
  padding-left: 120px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-6 {
  padding-right: 120px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-7 {
  padding-left: 140px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-7 {
  padding-right: 140px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-8 {
  padding-left: 160px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-8 {
  padding-right: 160px;
}

.ag-theme-balham .ag-ltr .ag-column-select-indent-9 {
  padding-left: 180px;
}

.ag-theme-balham .ag-rtl .ag-column-select-indent-9 {
  padding-right: 180px;
}

.ag-theme-balham .ag-column-select-header-icon {
  cursor: pointer;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-select-header-icon:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-select-header-icon:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-label:not(:last-child) {
  margin-right: 8px;
}

.ag-theme-balham .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-label:not(:last-child) {
  margin-left: 8px;
}

.ag-theme-balham .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-column-select-column-group:not(:last-child),
.ag-theme-balham .ag-column-select-column:not(:last-child) {
  margin-bottom: 4px;
}
.ag-theme-balham .ag-column-select-column-readonly,
.ag-theme-balham .ag-column-select-column-group-readonly {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  pointer-events: none;
}
.ag-theme-balham .ag-ltr .ag-column-select-add-group-indent {
  margin-left: 24px;
}

.ag-theme-balham .ag-rtl .ag-column-select-add-group-indent {
  margin-right: 24px;
}

.ag-theme-balham .ag-column-select-virtual-list-viewport {
  padding: 3px 0px;
}
.ag-theme-balham .ag-column-select-virtual-list-item {
  padding: 0 6px;
}
.ag-theme-balham .ag-rtl {
  text-align: right;
}
.ag-theme-balham .ag-root-wrapper {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-left: 40px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-right: 40px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-1 {
  padding-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-1 {
  padding-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-left: 68px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-right: 68px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-2 {
  padding-left: 56px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-2 {
  padding-right: 56px;
}

.ag-theme-balham .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-left: 96px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-right: 96px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-3 {
  padding-left: 84px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-3 {
  padding-right: 84px;
}

.ag-theme-balham .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-left: 124px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-right: 124px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-4 {
  padding-left: 112px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-4 {
  padding-right: 112px;
}

.ag-theme-balham .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-left: 152px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-right: 152px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-5 {
  padding-left: 140px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-5 {
  padding-right: 140px;
}

.ag-theme-balham .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-left: 180px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-right: 180px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-6 {
  padding-left: 168px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-6 {
  padding-right: 168px;
}

.ag-theme-balham .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-left: 208px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-right: 208px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-7 {
  padding-left: 196px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-7 {
  padding-right: 196px;
}

.ag-theme-balham .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-left: 236px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-right: 236px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-8 {
  padding-left: 224px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-8 {
  padding-right: 224px;
}

.ag-theme-balham .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-left: 264px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-right: 264px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-9 {
  padding-left: 252px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-9 {
  padding-right: 252px;
}

.ag-theme-balham .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-left: 292px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-right: 292px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-10 {
  padding-left: 280px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-10 {
  padding-right: 280px;
}

.ag-theme-balham .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-left: 320px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-right: 320px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-11 {
  padding-left: 308px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-11 {
  padding-right: 308px;
}

.ag-theme-balham .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-left: 348px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-right: 348px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-12 {
  padding-left: 336px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-12 {
  padding-right: 336px;
}

.ag-theme-balham .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-left: 376px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-right: 376px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-13 {
  padding-left: 364px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-13 {
  padding-right: 364px;
}

.ag-theme-balham .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-left: 404px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-right: 404px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-14 {
  padding-left: 392px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-14 {
  padding-right: 392px;
}

.ag-theme-balham .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-left: 432px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-right: 432px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-15 {
  padding-left: 420px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-15 {
  padding-right: 420px;
}

.ag-theme-balham .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-left: 460px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-right: 460px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-16 {
  padding-left: 448px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-16 {
  padding-right: 448px;
}

.ag-theme-balham .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-left: 488px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-right: 488px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-17 {
  padding-left: 476px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-17 {
  padding-right: 476px;
}

.ag-theme-balham .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-left: 516px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-right: 516px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-18 {
  padding-left: 504px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-18 {
  padding-right: 504px;
}

.ag-theme-balham .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-left: 544px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-right: 544px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-19 {
  padding-left: 532px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-19 {
  padding-right: 532px;
}

.ag-theme-balham .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-left: 572px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-right: 572px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-20 {
  padding-left: 560px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-20 {
  padding-right: 560px;
}

.ag-theme-balham .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-left: 600px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-right: 600px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-21 {
  padding-left: 588px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-21 {
  padding-right: 588px;
}

.ag-theme-balham .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-left: 628px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-right: 628px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-22 {
  padding-left: 616px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-22 {
  padding-right: 616px;
}

.ag-theme-balham .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-left: 656px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-right: 656px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-23 {
  padding-left: 644px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-23 {
  padding-right: 644px;
}

.ag-theme-balham .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-left: 684px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-right: 684px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-24 {
  padding-left: 672px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-24 {
  padding-right: 672px;
}

.ag-theme-balham .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-left: 712px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-right: 712px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-25 {
  padding-left: 700px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-25 {
  padding-right: 700px;
}

.ag-theme-balham .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-left: 740px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-right: 740px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-26 {
  padding-left: 728px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-26 {
  padding-right: 728px;
}

.ag-theme-balham .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-left: 768px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-right: 768px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-27 {
  padding-left: 756px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-27 {
  padding-right: 756px;
}

.ag-theme-balham .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-left: 796px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-right: 796px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-28 {
  padding-left: 784px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-28 {
  padding-right: 784px;
}

.ag-theme-balham .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-left: 824px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-right: 824px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-29 {
  padding-left: 812px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-29 {
  padding-right: 812px;
}

.ag-theme-balham .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-left: 852px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-right: 852px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-30 {
  padding-left: 840px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-30 {
  padding-right: 840px;
}

.ag-theme-balham .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-left: 880px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-right: 880px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-31 {
  padding-left: 868px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-31 {
  padding-right: 868px;
}

.ag-theme-balham .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-left: 908px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-right: 908px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-32 {
  padding-left: 896px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-32 {
  padding-right: 896px;
}

.ag-theme-balham .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-left: 936px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-right: 936px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-33 {
  padding-left: 924px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-33 {
  padding-right: 924px;
}

.ag-theme-balham .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-left: 964px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-right: 964px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-34 {
  padding-left: 952px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-34 {
  padding-right: 952px;
}

.ag-theme-balham .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-left: 992px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-right: 992px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-35 {
  padding-left: 980px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-35 {
  padding-right: 980px;
}

.ag-theme-balham .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-left: 1020px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-right: 1020px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-36 {
  padding-left: 1008px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-36 {
  padding-right: 1008px;
}

.ag-theme-balham .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-left: 1048px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-right: 1048px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-37 {
  padding-left: 1036px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-37 {
  padding-right: 1036px;
}

.ag-theme-balham .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-left: 1076px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-right: 1076px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-38 {
  padding-left: 1064px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-38 {
  padding-right: 1064px;
}

.ag-theme-balham .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-left: 1104px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-right: 1104px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-39 {
  padding-left: 1092px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-39 {
  padding-right: 1092px;
}

.ag-theme-balham .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-left: 1132px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-right: 1132px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-40 {
  padding-left: 1120px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-40 {
  padding-right: 1120px;
}

.ag-theme-balham .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-left: 1160px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-right: 1160px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-41 {
  padding-left: 1148px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-41 {
  padding-right: 1148px;
}

.ag-theme-balham .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-left: 1188px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-right: 1188px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-42 {
  padding-left: 1176px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-42 {
  padding-right: 1176px;
}

.ag-theme-balham .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-left: 1216px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-right: 1216px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-43 {
  padding-left: 1204px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-43 {
  padding-right: 1204px;
}

.ag-theme-balham .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-left: 1244px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-right: 1244px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-44 {
  padding-left: 1232px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-44 {
  padding-right: 1232px;
}

.ag-theme-balham .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-left: 1272px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-right: 1272px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-45 {
  padding-left: 1260px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-45 {
  padding-right: 1260px;
}

.ag-theme-balham .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-left: 1300px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-right: 1300px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-46 {
  padding-left: 1288px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-46 {
  padding-right: 1288px;
}

.ag-theme-balham .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-left: 1328px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-right: 1328px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-47 {
  padding-left: 1316px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-47 {
  padding-right: 1316px;
}

.ag-theme-balham .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-left: 1356px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-right: 1356px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-48 {
  padding-left: 1344px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-48 {
  padding-right: 1344px;
}

.ag-theme-balham .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-left: 1384px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-right: 1384px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-49 {
  padding-left: 1372px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-49 {
  padding-right: 1372px;
}

.ag-theme-balham .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-left: 1412px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-right: 1412px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-50 {
  padding-left: 1400px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-50 {
  padding-right: 1400px;
}

.ag-theme-balham .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-left: 1440px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-right: 1440px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-51 {
  padding-left: 1428px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-51 {
  padding-right: 1428px;
}

.ag-theme-balham .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-left: 1468px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-right: 1468px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-52 {
  padding-left: 1456px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-52 {
  padding-right: 1456px;
}

.ag-theme-balham .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-left: 1496px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-right: 1496px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-53 {
  padding-left: 1484px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-53 {
  padding-right: 1484px;
}

.ag-theme-balham .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-left: 1524px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-right: 1524px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-54 {
  padding-left: 1512px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-54 {
  padding-right: 1512px;
}

.ag-theme-balham .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-left: 1552px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-right: 1552px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-55 {
  padding-left: 1540px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-55 {
  padding-right: 1540px;
}

.ag-theme-balham .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-left: 1580px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-right: 1580px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-56 {
  padding-left: 1568px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-56 {
  padding-right: 1568px;
}

.ag-theme-balham .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-left: 1608px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-right: 1608px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-57 {
  padding-left: 1596px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-57 {
  padding-right: 1596px;
}

.ag-theme-balham .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-left: 1636px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-right: 1636px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-58 {
  padding-left: 1624px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-58 {
  padding-right: 1624px;
}

.ag-theme-balham .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-left: 1664px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-right: 1664px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-59 {
  padding-left: 1652px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-59 {
  padding-right: 1652px;
}

.ag-theme-balham .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-left: 1692px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-right: 1692px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-60 {
  padding-left: 1680px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-60 {
  padding-right: 1680px;
}

.ag-theme-balham .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-left: 1720px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-right: 1720px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-61 {
  padding-left: 1708px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-61 {
  padding-right: 1708px;
}

.ag-theme-balham .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-left: 1748px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-right: 1748px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-62 {
  padding-left: 1736px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-62 {
  padding-right: 1736px;
}

.ag-theme-balham .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-left: 1776px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-right: 1776px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-63 {
  padding-left: 1764px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-63 {
  padding-right: 1764px;
}

.ag-theme-balham .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-left: 1804px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-right: 1804px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-64 {
  padding-left: 1792px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-64 {
  padding-right: 1792px;
}

.ag-theme-balham .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-left: 1832px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-right: 1832px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-65 {
  padding-left: 1820px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-65 {
  padding-right: 1820px;
}

.ag-theme-balham .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-left: 1860px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-right: 1860px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-66 {
  padding-left: 1848px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-66 {
  padding-right: 1848px;
}

.ag-theme-balham .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-left: 1888px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-right: 1888px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-67 {
  padding-left: 1876px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-67 {
  padding-right: 1876px;
}

.ag-theme-balham .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-left: 1916px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-right: 1916px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-68 {
  padding-left: 1904px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-68 {
  padding-right: 1904px;
}

.ag-theme-balham .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-left: 1944px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-right: 1944px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-69 {
  padding-left: 1932px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-69 {
  padding-right: 1932px;
}

.ag-theme-balham .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-left: 1972px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-right: 1972px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-70 {
  padding-left: 1960px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-70 {
  padding-right: 1960px;
}

.ag-theme-balham .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-left: 2000px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-right: 2000px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-71 {
  padding-left: 1988px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-71 {
  padding-right: 1988px;
}

.ag-theme-balham .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-left: 2028px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-right: 2028px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-72 {
  padding-left: 2016px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-72 {
  padding-right: 2016px;
}

.ag-theme-balham .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-left: 2056px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-right: 2056px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-73 {
  padding-left: 2044px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-73 {
  padding-right: 2044px;
}

.ag-theme-balham .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-left: 2084px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-right: 2084px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-74 {
  padding-left: 2072px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-74 {
  padding-right: 2072px;
}

.ag-theme-balham .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-left: 2112px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-right: 2112px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-75 {
  padding-left: 2100px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-75 {
  padding-right: 2100px;
}

.ag-theme-balham .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-left: 2140px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-right: 2140px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-76 {
  padding-left: 2128px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-76 {
  padding-right: 2128px;
}

.ag-theme-balham .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-left: 2168px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-right: 2168px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-77 {
  padding-left: 2156px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-77 {
  padding-right: 2156px;
}

.ag-theme-balham .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-left: 2196px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-right: 2196px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-78 {
  padding-left: 2184px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-78 {
  padding-right: 2184px;
}

.ag-theme-balham .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-left: 2224px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-right: 2224px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-79 {
  padding-left: 2212px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-79 {
  padding-right: 2212px;
}

.ag-theme-balham .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-left: 2252px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-right: 2252px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-80 {
  padding-left: 2240px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-80 {
  padding-right: 2240px;
}

.ag-theme-balham .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-left: 2280px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-right: 2280px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-81 {
  padding-left: 2268px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-81 {
  padding-right: 2268px;
}

.ag-theme-balham .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-left: 2308px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-right: 2308px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-82 {
  padding-left: 2296px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-82 {
  padding-right: 2296px;
}

.ag-theme-balham .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-left: 2336px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-right: 2336px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-83 {
  padding-left: 2324px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-83 {
  padding-right: 2324px;
}

.ag-theme-balham .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-left: 2364px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-right: 2364px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-84 {
  padding-left: 2352px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-84 {
  padding-right: 2352px;
}

.ag-theme-balham .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-left: 2392px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-right: 2392px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-85 {
  padding-left: 2380px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-85 {
  padding-right: 2380px;
}

.ag-theme-balham .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-left: 2420px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-right: 2420px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-86 {
  padding-left: 2408px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-86 {
  padding-right: 2408px;
}

.ag-theme-balham .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-left: 2448px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-right: 2448px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-87 {
  padding-left: 2436px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-87 {
  padding-right: 2436px;
}

.ag-theme-balham .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-left: 2476px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-right: 2476px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-88 {
  padding-left: 2464px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-88 {
  padding-right: 2464px;
}

.ag-theme-balham .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-left: 2504px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-right: 2504px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-89 {
  padding-left: 2492px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-89 {
  padding-right: 2492px;
}

.ag-theme-balham .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-left: 2532px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-right: 2532px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-90 {
  padding-left: 2520px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-90 {
  padding-right: 2520px;
}

.ag-theme-balham .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-left: 2560px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-right: 2560px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-91 {
  padding-left: 2548px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-91 {
  padding-right: 2548px;
}

.ag-theme-balham .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-left: 2588px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-right: 2588px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-92 {
  padding-left: 2576px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-92 {
  padding-right: 2576px;
}

.ag-theme-balham .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-left: 2616px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-right: 2616px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-93 {
  padding-left: 2604px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-93 {
  padding-right: 2604px;
}

.ag-theme-balham .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-left: 2644px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-right: 2644px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-94 {
  padding-left: 2632px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-94 {
  padding-right: 2632px;
}

.ag-theme-balham .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-left: 2672px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-right: 2672px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-95 {
  padding-left: 2660px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-95 {
  padding-right: 2660px;
}

.ag-theme-balham .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-left: 2700px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-right: 2700px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-96 {
  padding-left: 2688px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-96 {
  padding-right: 2688px;
}

.ag-theme-balham .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-left: 2728px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-right: 2728px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-97 {
  padding-left: 2716px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-97 {
  padding-right: 2716px;
}

.ag-theme-balham .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-left: 2756px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-right: 2756px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-98 {
  padding-left: 2744px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-98 {
  padding-right: 2744px;
}

.ag-theme-balham .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-left: 2784px;
}

.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-right: 2784px;
}

.ag-theme-balham .ag-ltr .ag-row-group-indent-99 {
  padding-left: 2772px;
}

.ag-theme-balham .ag-rtl .ag-row-group-indent-99 {
  padding-right: 2772px;
}

.ag-theme-balham .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 28px;
}

.ag-theme-balham .ag-rtl .ag-row-group-leaf-indent {
  margin-right: 28px;
}

.ag-theme-balham .ag-value-change-delta {
  padding-right: 2px;
}
.ag-theme-balham .ag-value-change-delta-up {
  color: #43a047;
  color: var(--ag-value-change-delta-up-color, #43a047);
}
.ag-theme-balham .ag-value-change-delta-down {
  color: #e53935;
  color: var(--ag-value-change-delta-down-color, #e53935);
}
.ag-theme-balham .ag-value-change-value {
  background-color: transparent;
  border-radius: 1px;
  padding-left: 1px;
  padding-right: 1px;
  -webkit-transition: background-color 1s;
  transition: background-color 1s;
}
.ag-theme-balham .ag-value-change-value-highlight {
  background-color: rgba(22, 160, 133, 0.5);
  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5));
  -webkit-transition: background-color 0.1s;
  transition: background-color 0.1s;
}
.ag-theme-balham .ag-cell-data-changed {
  background-color: rgba(22, 160, 133, 0.5) !important;
  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5)) !important;
}
.ag-theme-balham .ag-cell-data-changed-animation {
  background-color: transparent;
}
.ag-theme-balham .ag-cell-highlight {
  background-color: #0091ea !important;
  background-color: var(--ag-range-selection-highlight-color, var(--ag-balham-active-color, #0091ea)) !important;
}
.ag-theme-balham .ag-row {
  height: 28px;
  background-color: white;
  background-color: var(--ag-background-color, white);
  color: #000;
  color: var(--ag-data-color, var(--ag-foreground-color, #000));
  border-width: 1px;
  border-color: #d9dcde;
  border-color: var(--ag-row-border-color, #d9dcde);
  border-bottom-style: solid;
}
.ag-theme-balham .ag-row-highlight-above::after, .ag-theme-balham .ag-row-highlight-below::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: 1px;
  background-color: #0091ea;
  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
  left: 1px;
}
.ag-theme-balham .ag-row-highlight-above::after {
  top: -1px;
}
.ag-theme-balham .ag-row-highlight-above.ag-row-first::after {
  top: 0;
}
.ag-theme-balham .ag-row-highlight-below::after {
  bottom: 0px;
}
.ag-theme-balham .ag-row-odd {
  background-color: #fcfdfe;
  background-color: var(--ag-odd-row-background-color, #fcfdfe);
}
.ag-theme-balham .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-row-hover {
  background-color: #ecf0f1;
  background-color: var(--ag-row-hover-color, #ecf0f1);
}
.ag-theme-balham .ag-column-hover {
  background-color: #ecf0f1;
  background-color: var(--ag-column-hover-color, #ecf0f1);
}
.ag-theme-balham .ag-ltr .ag-right-aligned-cell {
  text-align: right;
}

.ag-theme-balham .ag-rtl .ag-right-aligned-cell {
  text-align: left;
}

.ag-theme-balham .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-balham .ag-ltr .ag-right-aligned-cell .ag-group-value {
  margin-left: auto;
}

.ag-theme-balham .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-balham .ag-rtl .ag-right-aligned-cell .ag-group-value {
  margin-right: auto;
}

.ag-theme-balham .ag-cell, .ag-theme-balham .ag-full-width-row .ag-cell-wrapper.ag-row-group {
  border: 1px solid transparent;
  line-height: min(var(--ag-line-height, 26px), 26px);
  padding-left: 11px;
  padding-right: 11px;
  -webkit-font-smoothing: subpixel-antialiased;
}
.ag-theme-balham .ag-row > .ag-cell-wrapper {
  padding-left: 11px;
  padding-right: 11px;
}
.ag-theme-balham .ag-row-dragging {
  cursor: move;
  opacity: 0.5;
}
.ag-theme-balham .ag-cell-inline-editing {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
  padding: 0;
  height: 28px;
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
}
.ag-theme-balham .ag-popup-editor {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
  padding: 0;
}
.ag-theme-balham .ag-large-text-input {
  height: auto;
  padding: 12px;
}
.ag-theme-balham .ag-details-row {
  padding: 20px;
  background-color: white;
  background-color: var(--ag-background-color, white);
}
.ag-theme-balham .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-balham .ag-layout-auto-height .ag-center-cols-container, .ag-theme-balham .ag-layout-print .ag-center-cols-clipper, .ag-theme-balham .ag-layout-print .ag-center-cols-container {
  min-height: 50px;
}
.ag-theme-balham .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.66);
  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));
}
.ag-theme-balham .ag-overlay-loading-center {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
}
.ag-theme-balham .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 30px;
}
.ag-theme-balham .ag-loading {
  padding-left: 12px;
  display: -webkit-box;
  display: flex;
  height: 100%;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-balham .ag-loading-icon {
  padding-right: 12px;
}
.ag-theme-balham .ag-icon-loading {
  -webkit-animation-name: spin;
          animation-name: spin;
  -webkit-animation-duration: 1000ms;
          animation-duration: 1000ms;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.ag-theme-balham .ag-floating-top {
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-floating-bottom {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-cell {
  border-right: solid transparent;
}

.ag-theme-balham .ag-rtl .ag-cell {
  border-left: solid transparent;
}

.ag-theme-balham .ag-ltr .ag-cell {
  border-right-width: 1px;
}

.ag-theme-balham .ag-rtl .ag-cell {
  border-left-width: 1px;
}

.ag-theme-balham .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-row-selected {
  background-color: #b7e4ff;
  background-color: var(--ag-selected-row-background-color, #b7e4ff);
}
.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus),
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {
  background-color: rgba(0, 145, 234, 0.2);
  background-color: var(--ag-range-selection-background-color, rgba(0, 145, 234, 0.2));
}
.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {
  background-color: rgba(0, 88, 255, 0.1) !important;
  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;
}
.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {
  background-color: rgba(0, 255, 132, 0.1) !important;
  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;
}
.ag-theme-balham .ag-cell-range-selected-1:not(.ag-cell-focus),
.ag-theme-balham .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
  background-color: rgba(0, 145, 234, 0.2);
  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(0, 145, 234, 0.2)));
}
.ag-theme-balham .ag-cell-range-selected-2:not(.ag-cell-focus),
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {
  background-color: rgba(0, 145, 234, 0.36);
  background-color: var(--ag-range-selection-background-color-2, rgba(0, 145, 234, 0.36));
}
.ag-theme-balham .ag-cell-range-selected-3:not(.ag-cell-focus),
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {
  background-color: rgba(0, 145, 234, 0.488);
  background-color: var(--ag-range-selection-background-color-3, rgba(0, 145, 234, 0.488));
}
.ag-theme-balham .ag-cell-range-selected-4:not(.ag-cell-focus),
.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {
  background-color: rgba(0, 145, 234, 0.5904);
  background-color: var(--ag-range-selection-background-color-4, rgba(0, 145, 234, 0.5904));
}
.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
  border-top-color: #0091ea;
  border-top-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
  border-right-color: #0091ea;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
  border-bottom-color: #0091ea;
  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
  border-left-color: #0091ea;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-balham .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-balham .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-balham .ag-ltr .ag-cell-range-single-cell,
.ag-theme-balham .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-balham .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-balham .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-balham .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-balham .ag-rtl .ag-cell-range-single-cell,
.ag-theme-balham .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: 1px solid;
  border-color: #0091ea;
  border-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
  outline: initial;
}
.ag-theme-balham .ag-cell.ag-selection-fill-top,
.ag-theme-balham .ag-cell.ag-selection-fill-top.ag-cell-range-selected {
  border-top: 1px dashed;
  border-top-color: #0091ea;
  border-top-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #0091ea;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}

.ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #0091ea;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}

.ag-theme-balham .ag-cell.ag-selection-fill-bottom,
.ag-theme-balham .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {
  border-bottom: 1px dashed;
  border-bottom-color: #0091ea;
  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #0091ea;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}

.ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #0091ea;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}

.ag-theme-balham .ag-range-handle, .ag-theme-balham .ag-fill-handle {
  position: absolute;
  width: 6px;
  height: 6px;
  bottom: -1px;
  background-color: #0091ea;
  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-ltr .ag-range-handle, .ag-theme-balham .ag-ltr .ag-fill-handle {
  right: -1px;
}

.ag-theme-balham .ag-rtl .ag-range-handle, .ag-theme-balham .ag-rtl .ag-fill-handle {
  left: -1px;
}

.ag-theme-balham .ag-fill-handle {
  cursor: cell;
}
.ag-theme-balham .ag-range-handle {
  cursor: nwse-resize;
}
.ag-theme-balham .ag-cell-inline-editing {
  border-color: #719ECE !important;
  border-color: var(--ag-input-focus-border-color, #719ECE) !important;
}
.ag-theme-balham .ag-menu {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
  padding: 0;
}
.ag-theme-balham .ag-menu-list {
  cursor: default;
  padding: 4px 0;
}
.ag-theme-balham .ag-menu-separator {
  height: 9px;
}
.ag-theme-balham .ag-menu-separator-part::after {
  content: "";
  display: block;
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-menu-option-active, .ag-theme-balham .ag-compact-menu-option-active {
  background-color: #ecf0f1;
  background-color: var(--ag-row-hover-color, #ecf0f1);
}
.ag-theme-balham .ag-menu-option-part, .ag-theme-balham .ag-compact-menu-option-part {
  line-height: 16px;
  padding: 6px 0;
}
.ag-theme-balham .ag-menu-option-disabled, .ag-theme-balham .ag-compact-menu-option-disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-menu-option-icon, .ag-theme-balham .ag-compact-menu-option-icon {
  width: 16px;
}
.ag-theme-balham .ag-ltr .ag-menu-option-icon, .ag-theme-balham .ag-ltr .ag-compact-menu-option-icon {
  padding-left: 8px;
}

.ag-theme-balham .ag-rtl .ag-menu-option-icon, .ag-theme-balham .ag-rtl .ag-compact-menu-option-icon {
  padding-right: 8px;
}

.ag-theme-balham .ag-menu-option-text, .ag-theme-balham .ag-compact-menu-option-text {
  padding-left: 8px;
  padding-right: 8px;
}
.ag-theme-balham .ag-ltr .ag-menu-option-shortcut, .ag-theme-balham .ag-ltr .ag-compact-menu-option-shortcut {
  padding-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-menu-option-shortcut, .ag-theme-balham .ag-rtl .ag-compact-menu-option-shortcut {
  padding-left: 4px;
}

.ag-theme-balham .ag-menu-option-popup-pointer, .ag-theme-balham .ag-compact-menu-option-popup-pointer {
  padding-right: 4px;
}
.ag-theme-balham .ag-tabs {
  min-width: 220px;
}
.ag-theme-balham .ag-tabs-header {
  width: 100%;
  display: -webkit-box;
  display: flex;
}
.ag-theme-balham .ag-tab {
  border-bottom: 0 solid transparent;
  display: -webkit-box;
  display: flex;
  -webkit-box-flex: 0;
          flex: none;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  cursor: pointer;
}
.ag-theme-balham .ag-keyboard-focus .ag-tab:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-tab:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-tab-selected {
  border-bottom-color: #0091ea;
  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-menu-header {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-filter-separator {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-menu:not(.ag-tabs) .ag-filter-select {
  min-width: 167px;
}
.ag-theme-balham .ag-tabs .ag-filter-select {
  min-width: 206px;
}
.ag-theme-balham .ag-filter-select .ag-picker-field-wrapper {
  width: 0;
}
.ag-theme-balham .ag-filter-condition-operator {
  height: 17px;
}
.ag-theme-balham .ag-ltr .ag-filter-condition-operator-or {
  margin-left: 8px;
}

.ag-theme-balham .ag-rtl .ag-filter-condition-operator-or {
  margin-right: 8px;
}

.ag-theme-balham .ag-set-filter-select-all {
  padding-top: 6px;
}
.ag-theme-balham .ag-set-filter-list, .ag-theme-balham .ag-filter-no-matches {
  height: 144px;
}
.ag-theme-balham .ag-set-filter-filter {
  margin-top: 6px;
  margin-left: 6px;
  margin-right: 6px;
}
.ag-theme-balham .ag-filter-to {
  margin-top: 4px;
}
.ag-theme-balham .ag-mini-filter {
  margin: 6px 6px;
}
.ag-theme-balham .ag-set-filter-item {
  margin: 0px 6px;
}
.ag-theme-balham .ag-ltr .ag-set-filter-item-value {
  margin-left: 6px;
}

.ag-theme-balham .ag-rtl .ag-set-filter-item-value {
  margin-right: 6px;
}

.ag-theme-balham .ag-filter-apply-panel {
  padding: 6px 6px;
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-filter-apply-panel-button {
  line-height: 1.5;
}
.ag-theme-balham .ag-ltr .ag-filter-apply-panel-button {
  margin-left: 8px;
}

.ag-theme-balham .ag-rtl .ag-filter-apply-panel-button {
  margin-right: 8px;
}

.ag-theme-balham .ag-simple-filter-body-wrapper {
  padding: 6px 6px;
  padding-bottom: 2px;
}
.ag-theme-balham .ag-simple-filter-body-wrapper > * {
  margin-bottom: 4px;
}
.ag-theme-balham .ag-filter-no-matches {
  padding: 6px 6px;
}
.ag-theme-balham .ag-multi-filter-menu-item {
  margin: 4px 0;
}
.ag-theme-balham .ag-multi-filter-group-title-bar {
  padding: 8px 4px;
  background-color: transparent;
}
.ag-theme-balham .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-side-bar {
  position: relative;
}
.ag-theme-balham .ag-tool-panel-wrapper {
  width: 200px;
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
}
.ag-theme-balham .ag-side-buttons {
  padding-top: 16px;
  width: 20px;
  position: relative;
  color: #000;
  color: var(--ag-foreground-color, #000);
  overflow: hidden;
}
.ag-theme-balham button.ag-side-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  background: transparent;
  padding: 8px 0 8px 0;
  width: calc(100% + 1px);
  margin: 0;
  min-height: 72px;
  background-position-y: center;
  background-position-x: center;
  background-repeat: no-repeat;
  border: none;
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham button.ag-side-button-button:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-side-button-button:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-side-button-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-selected .ag-side-button-button {
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-side-button-icon-wrapper {
  margin-bottom: 3px;
}
.ag-theme-balham .ag-ltr .ag-side-bar-left,
.ag-theme-balham .ag-rtl .ag-side-bar-right {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-side-button-button,
.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-side-button-button {
  border-right: 0 solid transparent;
  margin-right: -1px;
  padding-right: 1px;
}
.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-right-color: #0091ea;
  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-rtl .ag-side-bar-left,
.ag-theme-balham .ag-ltr .ag-side-bar-right {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-side-button-button,
.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-side-button-button {
  border-left: 0 solid transparent;
  margin-left: -1px;
  padding-left: 1px;
}
.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-left-color: #0091ea;
  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-filter-toolpanel-header {
  height: 24px;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-header, .ag-theme-balham .ag-ltr .ag-filter-toolpanel-search {
  padding-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-header, .ag-theme-balham .ag-rtl .ag-filter-toolpanel-search {
  padding-right: 4px;
}

.ag-theme-balham .ag-keyboard-focus .ag-filter-toolpanel-header:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  font-family: "agGridBalham";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f114";
  position: absolute;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-right: 4px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-0-header {
  height: 32px;
}
.ag-theme-balham .ag-filter-toolpanel-group-item {
  margin-top: 2px;
  margin-bottom: 2px;
}
.ag-theme-balham .ag-filter-toolpanel-search {
  height: 32px;
}
.ag-theme-balham .ag-filter-toolpanel-search-input {
  -webkit-box-flex: 1;
          flex-grow: 1;
  height: 16px;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-search-input {
  margin-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-search-input {
  margin-left: 4px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-0 {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {
  margin-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {
  margin-left: 4px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-left: 20px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-right: 20px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-left: 36px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-right: 36px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-left: 52px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-right: 52px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-left: 68px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-right: 68px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-left: 84px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-right: 84px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-left: 100px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-right: 100px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-left: 116px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-right: 116px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-left: 132px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-right: 132px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-left: 148px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-right: 148px;
}

.ag-theme-balham .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-left: 164px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-right: 164px;
}

.ag-theme-balham .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {
  padding-left: 4px;
}
.ag-theme-balham .ag-filter-toolpanel-instance-filter {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
  margin-top: 4px;
}
.ag-theme-balham .ag-ltr .ag-filter-toolpanel-instance-header-icon {
  margin-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-filter-toolpanel-instance-header-icon {
  margin-right: 4px;
}

.ag-theme-balham .ag-pivot-mode-panel {
  min-height: 32px;
  height: 32px;
  display: -webkit-box;
  display: flex;
}
.ag-theme-balham .ag-pivot-mode-select {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-balham .ag-ltr .ag-pivot-mode-select {
  margin-left: 6px;
}

.ag-theme-balham .ag-rtl .ag-pivot-mode-select {
  margin-right: 6px;
}

.ag-theme-balham .ag-keyboard-focus .ag-column-select-header:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-select-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-column-select-header {
  height: 32px;
  -webkit-box-align: center;
          align-items: center;
  padding: 0 6px;
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-column-panel-column-select {
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-column-group-icons,
.ag-theme-balham .ag-column-select-header-icon {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-column-select-list .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #0091ea;
  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-column-select-list .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-balham .ag-column-select-list .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-balham .ag-header {
  background-color: #f5f7f7;
  background-color: var(--ag-header-background-color, #f5f7f7);
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-header-row {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
  height: 32px;
}
.ag-theme-balham .ag-pinned-right-header {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-pinned-left-header {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-right: 4px;
}

.ag-theme-balham .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-left: 4px;
}

.ag-theme-balham .ag-header-cell,
.ag-theme-balham .ag-header-group-cell {
  padding-left: 12px;
  padding-right: 12px;
}
.ag-theme-balham .ag-header-cell.ag-header-cell-moving,
.ag-theme-balham .ag-header-group-cell.ag-header-cell-moving {
  background-color: white;
  background-color: var(--ag-header-cell-moving-background-color, var(--ag-background-color, white));
}
.ag-theme-balham .ag-keyboard-focus .ag-header-cell:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-header-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-keyboard-focus .ag-header-group-cell:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-header-group-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-header-icon {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-header-expand-icon {
  cursor: pointer;
}
.ag-theme-balham .ag-ltr .ag-header-expand-icon {
  padding-left: 4px;
}

.ag-theme-balham .ag-rtl .ag-header-expand-icon {
  padding-right: 4px;
}

.ag-theme-balham .ag-header-row:not(:first-child) .ag-header-cell,
.ag-theme-balham .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-header-cell::after,
.ag-theme-balham .ag-header-group-cell::after {
  content: "";
  position: absolute;
  z-index: 1;
  display: block;
  width: 1px;
  height: 50%;
  top: calc(50% - 25%);
  background-color: rgba(189, 195, 199, 0.5);
  background-color: var(--ag-header-column-separator-color, rgba(189, 195, 199, 0.5));
}
.ag-theme-balham .ag-ltr .ag-header-cell::after, .ag-theme-balham .ag-ltr .ag-header-group-cell::after {
  right: 0;
}

.ag-theme-balham .ag-rtl .ag-header-cell::after, .ag-theme-balham .ag-rtl .ag-header-group-cell::after {
  left: 0;
}

.ag-theme-balham .ag-ltr .ag-header-select-all {
  margin-right: 12px;
}

.ag-theme-balham .ag-rtl .ag-header-select-all {
  margin-left: 12px;
}

.ag-theme-balham .ag-ltr .ag-floating-filter-button {
  margin-left: 12px;
}

.ag-theme-balham .ag-rtl .ag-floating-filter-button {
  margin-right: 12px;
}

.ag-theme-balham .ag-floating-filter-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  height: 16px;
  padding: 0;
  width: 16px;
}
.ag-theme-balham .ag-filter-loading {
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
  height: 100%;
  padding: 6px 6px;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.ag-theme-balham .ag-paging-panel {
  border-top: 1px solid;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 32px;
}
.ag-theme-balham .ag-paging-panel > * {
  margin: 0 12px;
}
.ag-theme-balham .ag-paging-button {
  cursor: pointer;
}
.ag-theme-balham .ag-paging-button.ag-disabled {
  cursor: default;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-balham .ag-keyboard-focus .ag-paging-button:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-paging-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-paging-button, .ag-theme-balham .ag-paging-description {
  margin: 0 4px;
}
.ag-theme-balham .ag-status-bar {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-border-color, #bdc3c7);
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  padding-right: 16px;
  padding-left: 16px;
  line-height: 1.5;
}
.ag-theme-balham .ag-status-name-value-value {
  color: #000;
  color: var(--ag-foreground-color, #000);
}
.ag-theme-balham .ag-status-bar-center {
  text-align: center;
}
.ag-theme-balham .ag-status-name-value {
  margin-left: 4px;
  margin-right: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.ag-theme-balham .ag-column-drop-cell {
  background: #dddede;
  background: var(--ag-chip-background-color, #dddede);
  border-radius: 16px;
  height: 16px;
  padding: 0 2px;
  border: 1px solid transparent;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-drop-cell:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-column-drop-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 2px;
  left: 2px;
  display: block;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-column-drop-cell-text {
  margin: 0 4px;
}
.ag-theme-balham .ag-column-drop-cell-button {
  min-width: 16px;
  margin: 0 2px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-column-drop-cell-drag-handle {
  margin-left: 8px;
}
.ag-theme-balham .ag-column-drop-cell-ghost {
  opacity: 0.5;
}
.ag-theme-balham .ag-column-drop-horizontal {
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 28px;
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-ltr .ag-column-drop-horizontal {
  padding-left: 12px;
}

.ag-theme-balham .ag-rtl .ag-column-drop-horizontal {
  padding-right: 12px;
}

.ag-theme-balham .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}

.ag-theme-balham .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}

.ag-theme-balham .ag-column-drop-horizontal-cell-separator {
  margin: 0 4px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-column-drop-horizontal-empty-message {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-balham .ag-ltr .ag-column-drop-horizontal-icon {
  margin-right: 12px;
}

.ag-theme-balham .ag-rtl .ag-column-drop-horizontal-icon {
  margin-left: 12px;
}

.ag-theme-balham .ag-column-drop-vertical-list {
  padding-bottom: 4px;
  padding-right: 4px;
  padding-left: 4px;
}
.ag-theme-balham .ag-column-drop-vertical-cell {
  margin-top: 4px;
}
.ag-theme-balham .ag-column-drop-vertical {
  min-height: 50px;
  border-bottom: solid 1px;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-column-drop-vertical.ag-last-column-drop {
  border-bottom: none;
}
.ag-theme-balham .ag-column-drop-vertical-icon {
  margin-left: 4px;
  margin-right: 4px;
}
.ag-theme-balham .ag-column-drop-vertical-empty-message {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  margin-top: 4px;
}
.ag-theme-balham .ag-select-agg-func-popup {
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  background: white;
  background: var(--ag-background-color, white);
  border-radius: 2px;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 4px;
  background: white;
  background: var(--ag-background-color, white);
  height: 70px;
  padding: 0;
}
.ag-theme-balham .ag-select-agg-func-virtual-list-item {
  cursor: default;
  padding-left: 8px;
}
.ag-theme-balham .ag-select-agg-func-virtual-list-item:hover {
  background-color: #b7e4ff;
  background-color: var(--ag-selected-row-background-color, #b7e4ff);
}
.ag-theme-balham .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {
  outline: none;
}
.ag-theme-balham .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: #719ECE;
  border-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham .ag-chart-menu {
  border-radius: 2px;
  background: white;
  background: var(--ag-background-color, white);
}
.ag-theme-balham .ag-chart-menu-icon {
  opacity: 0.5;
  line-height: 24px;
  font-size: 24px;
  width: 24px;
  height: 24px;
  margin: 2px 0;
  cursor: pointer;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-chart-menu-icon:hover {
  opacity: 1;
}
.ag-theme-balham .ag-chart-mini-thumbnail {
  border: 1px solid;
  border-color: #bdc3c7;
  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
  border-radius: 5px;
  margin: 5px;
}
.ag-theme-balham .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-balham .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {
  margin-left: auto;
  margin-right: auto;
}
.ag-theme-balham .ag-ltr .ag-chart-mini-thumbnail:first-child {
  margin-left: 0;
}

.ag-theme-balham .ag-rtl .ag-chart-mini-thumbnail:first-child {
  margin-right: 0;
}

.ag-theme-balham .ag-ltr .ag-chart-mini-thumbnail:last-child {
  margin-right: 0;
}

.ag-theme-balham .ag-rtl .ag-chart-mini-thumbnail:last-child {
  margin-left: 0;
}

.ag-theme-balham .ag-chart-mini-thumbnail.ag-selected {
  border-color: #0091ea;
  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-chart-settings-card-item {
  background: #000;
  background: var(--ag-foreground-color, #000);
  width: 8px;
  height: 8px;
  border-radius: 4px;
}
.ag-theme-balham .ag-chart-settings-card-item.ag-selected {
  background-color: #0091ea;
  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-chart-data-column-drag-handle {
  margin-left: 4px;
}
.ag-theme-balham .ag-charts-settings-group-title-bar,
.ag-theme-balham .ag-charts-data-group-title-bar,
.ag-theme-balham .ag-charts-format-top-level-group-title-bar {
  border-top: solid 1px;
  border-top-color: #bdc3c7;
  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));
}
.ag-theme-balham .ag-charts-settings-group-container {
  padding: 4px;
}
.ag-theme-balham .ag-charts-data-group-container {
  padding: 3px 6px;
}
.ag-theme-balham .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {
  height: 24px;
}
.ag-theme-balham .ag-charts-data-group-container .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #0091ea;
  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham .ag-charts-data-group-container .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-balham .ag-charts-data-group-container .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-balham .ag-charts-format-top-level-group-container {
  margin-left: 8px;
  padding: 4px;
}
.ag-theme-balham .ag-charts-format-top-level-group-item {
  margin: 4px 0;
}
.ag-theme-balham .ag-charts-format-sub-level-group-container {
  padding: 6px 6px;
  padding-bottom: 2px;
}
.ag-theme-balham .ag-charts-format-sub-level-group-container > * {
  margin-bottom: 4px;
}
.ag-theme-balham .ag-charts-group-container.ag-group-container-horizontal {
  padding: 4px;
}
.ag-theme-balham .ag-chart-data-section,
.ag-theme-balham .ag-chart-format-section {
  display: -webkit-box;
  display: flex;
  margin: 0;
}
.ag-theme-balham .ag-chart-menu-panel {
  background-color: #f5f7f7;
  background-color: var(--ag-control-panel-background-color, #f5f7f7);
}
.ag-theme-balham .ag-ltr .ag-chart-menu-panel {
  border-left: solid 1px;
  border-left-color: #bdc3c7;
  border-left-color: var(--ag-border-color, #bdc3c7);
}

.ag-theme-balham .ag-rtl .ag-chart-menu-panel {
  border-right: solid 1px;
  border-right-color: #bdc3c7;
  border-right-color: var(--ag-border-color, #bdc3c7);
}

.ag-theme-balham .ag-date-time-list-page-title {
  -webkit-box-flex: 1;
          flex-grow: 1;
  text-align: center;
}
.ag-theme-balham .ag-date-time-list-page-column-label {
  text-align: center;
}
.ag-theme-balham .ag-date-time-list-page-entry {
  text-align: center;
}
.ag-theme-balham .ag-checkbox-input-wrapper {
  font-family: "agGridBalham";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 16px;
  height: 16px;
  background-color: white;
  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, white));
  border-radius: 3px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-balham .ag-checkbox-input-wrapper input, .ag-theme-balham .ag-checkbox-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-balham .ag-checkbox-input-wrapper:focus-within, .ag-theme-balham .ag-checkbox-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
}
.ag-theme-balham .ag-checkbox-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-checkbox-input-wrapper::after {
  content: "\\f108";
  color: #7f8c8d;
  color: var(--ag-checkbox-unchecked-color, #7f8c8d);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-balham .ag-checkbox-input-wrapper.ag-checked::after {
  content: "\\f106";
  color: #0091ea;
  color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-balham .ag-checkbox-input-wrapper.ag-indeterminate::after {
  content: "\\f107";
  color: #7f8c8d;
  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #7f8c8d));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-balham .ag-toggle-button-input-wrapper {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 32px;
  height: 16px;
  background-color: #7f8c8d;
  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #7f8c8d));
  border-radius: 8px;
  position: relative;
  -webkit-box-flex: 0;
          flex: none;
  border: 1px solid;
  border-color: #7f8c8d;
  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #7f8c8d));
}
.ag-theme-balham .ag-toggle-button-input-wrapper input {
  opacity: 0;
  height: 100%;
  width: 100%;
}
.ag-theme-balham .ag-toggle-button-input-wrapper:focus-within {
  outline: none;
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
}
.ag-theme-balham .ag-toggle-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-toggle-button-input-wrapper.ag-checked {
  background-color: #0091ea;
  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));
  border-color: #0091ea;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-toggle-button-input-wrapper::before {
  content: " ";
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 16px;
  width: 16px;
  background-color: white;
  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, white));
  border-radius: 8px;
  -webkit-transition: left 100ms;
  transition: left 100ms;
  border: 1px solid;
  border-color: #7f8c8d;
  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #7f8c8d)));
}
.ag-theme-balham .ag-toggle-button-input-wrapper.ag-checked::before {
  left: calc(100% - 16px );
  border-color: #0091ea;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));
}
.ag-theme-balham .ag-radio-button-input-wrapper {
  font-family: "agGridBalham";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 16px;
  height: 16px;
  background-color: white;
  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, white));
  border-radius: 3px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
  border-radius: 16px;
}
.ag-theme-balham .ag-radio-button-input-wrapper input, .ag-theme-balham .ag-radio-button-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-balham .ag-radio-button-input-wrapper:focus-within, .ag-theme-balham .ag-radio-button-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
}
.ag-theme-balham .ag-radio-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-radio-button-input-wrapper::after {
  content: "\\f126";
  color: #7f8c8d;
  color: var(--ag-checkbox-unchecked-color, #7f8c8d);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-balham .ag-radio-button-input-wrapper.ag-checked::after {
  content: "\\f127";
  color: #0091ea;
  color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-balham input[class^=ag-][type=range] {
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  background: none;
  overflow: visible;
}
.ag-theme-balham input[class^=ag-][type=range]::-webkit-slider-runnable-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #bdc3c7;
  background-color: var(--ag-border-color, #bdc3c7);
  border-radius: 2px;
  border-radius: 3px;
}
.ag-theme-balham input[class^=ag-][type=range]::-moz-range-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #bdc3c7;
  background-color: var(--ag-border-color, #bdc3c7);
  border-radius: 2px;
  border-radius: 3px;
}
.ag-theme-balham input[class^=ag-][type=range]::-ms-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #bdc3c7;
  background-color: var(--ag-border-color, #bdc3c7);
  border-radius: 2px;
  border-radius: 3px;
  color: transparent;
  width: calc(100% - 2px);
}
.ag-theme-balham input[class^=ag-][type=range]::-webkit-slider-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: white;
  background-color: var(--ag-background-color, white);
  border: 1px solid;
  border-color: #7f8c8d;
  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);
  border-radius: 16px;
  -webkit-transform: translateY(-6.5px);
          transform: translateY(-6.5px);
}
.ag-theme-balham input[class^=ag-][type=range]::-ms-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: white;
  background-color: var(--ag-background-color, white);
  border: 1px solid;
  border-color: #7f8c8d;
  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);
  border-radius: 16px;
}
.ag-theme-balham input[class^=ag-][type=range]::-moz-ag-range-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: white;
  background-color: var(--ag-background-color, white);
  border: 1px solid;
  border-color: #7f8c8d;
  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);
  border-radius: 16px;
}
.ag-theme-balham input[class^=ag-][type=range]:focus {
  outline: none;
}
.ag-theme-balham input[class^=ag-][type=range]:focus::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 2px 1px #719ECE;
          box-shadow: 0 0 2px 1px #719ECE;
  border-color: #0091ea;
  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham input[class^=ag-][type=range]:focus::-ms-thumb {
  box-shadow: 0 0 2px 1px #719ECE;
  border-color: #0091ea;
  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {
  box-shadow: 0 0 2px 1px #719ECE;
  border-color: #0091ea;
  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));
}
.ag-theme-balham input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {
  background-color: #719ECE;
  background-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham input[class^=ag-][type=range]:active::-moz-ag-range-track {
  background-color: #719ECE;
  background-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham input[class^=ag-][type=range]:active::-ms-track {
  background-color: #719ECE;
  background-color: var(--ag-input-focus-border-color, #719ECE);
}
.ag-theme-balham input[class^=ag-][type=range]:disabled {
  opacity: 0.5;
}
.ag-theme-balham .ag-filter-toolpanel-header,
.ag-theme-balham .ag-filter-toolpanel-search,
.ag-theme-balham .ag-status-bar,
.ag-theme-balham .ag-header-row,
.ag-theme-balham .ag-multi-filter-group-title-bar {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
}
.ag-theme-balham .ag-ltr input[class^=ag-]:not([type]),
.ag-theme-balham .ag-ltr input[class^=ag-][type=text],
.ag-theme-balham .ag-ltr input[class^=ag-][type=number],
.ag-theme-balham .ag-ltr input[class^=ag-][type=tel],
.ag-theme-balham .ag-ltr input[class^=ag-][type=date],
.ag-theme-balham .ag-ltr input[class^=ag-][type=datetime-local],
.ag-theme-balham .ag-ltr textarea[class^=ag-] {
  padding-left: 4px;
}

.ag-theme-balham .ag-rtl input[class^=ag-]:not([type]),
.ag-theme-balham .ag-rtl input[class^=ag-][type=text],
.ag-theme-balham .ag-rtl input[class^=ag-][type=number],
.ag-theme-balham .ag-rtl input[class^=ag-][type=tel],
.ag-theme-balham .ag-rtl input[class^=ag-][type=date],
.ag-theme-balham .ag-rtl input[class^=ag-][type=datetime-local],
.ag-theme-balham .ag-rtl textarea[class^=ag-] {
  padding-right: 4px;
}

.ag-theme-balham .ag-column-drop-vertical-empty-message, .ag-theme-balham .ag-status-bar {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-balham .ag-dnd-ghost {
  font-weight: 600;
}
.ag-theme-balham .ag-tab {
  border: 1px solid transparent;
  padding: 4px 8px;
  margin: 4px;
  margin-bottom: -1px;
}
.ag-theme-balham .ag-tab-selected {
  background-color: white;
  background-color: var(--ag-background-color, white);
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  border-bottom-color: transparent;
}
.ag-theme-balham .ag-tabs-header {
  border-bottom: 1px solid;
  border-bottom-color: #bdc3c7;
  border-bottom-color: var(--ag-border-color, #bdc3c7);
}
.ag-theme-balham .ag-column-drop-cell {
  height: 24px;
}
.ag-theme-balham .ag-column-drop-vertical-title {
  color: #000;
  color: var(--ag-foreground-color, #000);
}
.ag-theme-balham .ag-column-drop-vertical-cell {
  margin-left: 8px;
  margin-right: 8px;
}
.ag-theme-balham .ag-column-drop-vertical-cell-text {
  margin-left: 8px;
}
.ag-theme-balham .ag-column-drop-vertical-icon {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-balham .ag-ltr .ag-column-drop-vertical-empty-message {
  padding-left: 24px;
  padding-right: 4px;
}

.ag-theme-balham .ag-rtl .ag-column-drop-vertical-empty-message {
  padding-right: 24px;
  padding-left: 4px;
}

.ag-theme-balham .ag-column-drop-horizontal {
  height: 32px;
}
.ag-theme-balham .ag-column-drop-empty {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-balham .ag-column-drop-horizontal-cell-text {
  margin-left: 8px;
}
.ag-theme-balham .ag-column-drop-vertical {
  padding-top: 8px;
}
.ag-theme-balham .ag-menu-header {
  background-color: #f5f7f7;
  background-color: var(--ag-header-background-color, #f5f7f7);
}
.ag-theme-balham .ag-overlay-loading-center {
  background-color: white;
  background-color: var(--ag-background-color, white);
  border: 1px solid;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
  color: #000;
  color: var(--ag-foreground-color, #000);
  padding: 16px;
}
.ag-theme-balham .ag-tooltip {
  border: none;
  background-color: #cbd0d3;
}
.ag-theme-balham .ag-panel-title-bar-button-icon {
  font-size: 20px;
}
.ag-theme-balham .ag-chart-data-section,
.ag-theme-balham .ag-chart-format-section {
  padding-bottom: 2px;
}
.ag-theme-balham .ag-group-toolbar {
  background-color: rgba(226, 233, 235, 0.5);
  background-color: var(--ag-subheader-toolbar-background-color, rgba(226, 233, 235, 0.5));
}
.ag-theme-balham .ag-chart-tab {
  padding-top: 2px;
}
.ag-theme-balham .ag-charts-format-sub-level-group-item {
  margin-bottom: 6px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ag-grid-community/dist/styles/ag-theme-balham.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,WAAW;EACX,uCAAuC;EACvC,gIAAgI;EAChI,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,2DAAmoQ;EACnoQ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,UAAU;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mDAAmD;AACrD;AACA;;EAEE,uBAAuB;EACvB,mDAAmD;AACrD;AACA;;;;;;;EAOE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;AACA;;;;;;;EAOE,0BAA0B;EAC1B,+DAA+D;EAC/D,yBAAyB;EACzB,oEAAoE;EACpE,sCAAsC;EACtC,6EAA6E;AAC/E;AACA;;;;;;;EAOE,aAAa;EACb,uCAAuC;UAC/B,+BAA+B;EACvC,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;;;;;;;EAOE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,oFAAoF;AACtF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,uCAAuC;UAC/B,+BAA+B;AACzC;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,sFAAsF;AACxF;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;AACA;;;;EAIE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;UACX,UAAU;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;UACX,UAAU;EAClB,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,2EAA2E;AAC7E;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,uCAAuC;UAC/B,+BAA+B;AACzC;AACA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wGAAwG;EACxG,0EAA0E;AAC5E;AACA;EACE,0GAA0G;EAC1G,wEAAwE;AAC1E;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,+EAA+E;EAC/E,0BAA0B;EAC1B,gEAAgE;EAChE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,kCAAkC;UAC1B,0BAA0B;AACpC;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,0BAA0B;EAC1B,mGAAmG;EACnG,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,+DAA+D;EAC/D,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,uDAAuD;AACzD;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,kGAAkG;EAClG,yCAAyC;EACzC,iCAAiC;AACnC;AACA;EACE,oDAAoD;EACpD,6GAA6G;AAC/G;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,8GAA8G;AAChH;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,WAAW;EACX,6DAA6D;EAC7D,iBAAiB;EACjB,qBAAqB;EACrB,iDAAiD;EACjD,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,gGAAgG;EAChG,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;EACnE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,qFAAqF;AACvF;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;UACpB,oBAAoB;EAC5B,kCAAkC;UAC1B,0BAA0B;EAClC,2CAA2C;UACnC,mCAAmC;EAC3C,yCAAyC;UACjC,iCAAiC;AAC3C;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;AACA;;EAEE,wCAAwC;EACxC,oFAAoF;AACtF;AACA;;EAEE,kDAAkD;EAClD,oGAAoG;AACtG;AACA;;EAEE,mDAAmD;EACnD,8GAA8G;AAChH;AACA;;EAEE,wCAAwC;EACxC,kIAAkI;AACpI;AACA;;EAEE,yCAAyC;EACzC,uFAAuF;AACzF;AACA;;EAEE,0CAA0C;EAC1C,wFAAwF;AAC1F;AACA;;EAEE,2CAA2C;EAC3C,yFAAyF;AAC3F;AACA;EACE,yBAAyB;EACzB,gGAAgG;AAClG;AACA;EACE,2BAA2B;EAC3B,kGAAkG;AACpG;AACA;EACE,4BAA4B;EAC5B,mGAAmG;AACrG;AACA;EACE,0BAA0B;EAC1B,iGAAiG;AACnG;AACA;;;;;;;;;EASE,iBAAiB;EACjB,qBAAqB;EACrB,4FAA4F;EAC5F,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,gGAAgG;AAClG;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kGAAkG;AACpG;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iGAAiG;AACnG;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,mGAAmG;AACrG;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iGAAiG;AACnG;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kGAAkG;AACpG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gGAAgG;AAClG;AACA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,oEAAoE;AACtE;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;UACX,UAAU;EAClB,yBAAyB;UACjB,mBAAmB;EAC3B,wBAAwB;UAChB,uBAAuB;EAC/B,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,4BAA4B;EAC5B,2IAA2I;AAC7I;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mFAAmF;AACrF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,yBAAyB;EACzB,iDAAiD;EACjD,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,0IAA0I;AAC5I;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;;EAEE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,0BAA0B;EAC1B,yIAAyI;AAC3I;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,YAAY;EACpB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mFAAmF;AACrF;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;EAC3B,cAAc;EACd,wBAAwB;EACxB,4BAA4B;EAC5B,sFAAsF;AACxF;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sFAAsF;EACtF,qBAAqB;EACrB,yBAAyB;EACzB,mFAAmF;AACrF;AACA;;EAEE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gGAAgG;AAClG;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,0BAA0B;EAC1B,mGAAmG;EACnG,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;EACvB,kGAAkG;AACpG;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,mFAAmF;AACrF;AACA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,0BAA0B;EAC1B,gEAAgE;EAChE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,0BAA0B;EAC1B,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,0BAA0B;EAC1B,gEAAgE;EAChE,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,sFAAsF;AACxF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;EACxB,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;EAC7C,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,+EAA+E;EAC/E,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gIAAgI;AAClI;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mIAAmI;AACrI;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,mFAAmF;AACrF;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gGAAgG;AAClG;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,oBAAoB;EACpB,aAAa;EACb,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;UACX,YAAY;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wFAAwF;EACxF,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,uCAAuC;UAC/B,+BAA+B;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,+EAA+E;EAC/E,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,0FAA0F;EAC1F,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2GAA2G;EAC3G,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;UACX,UAAU;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mGAAmG;AACrG;AACA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,uCAAuC;UAC/B,+BAA+B;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uIAAuI;EACvI,qBAAqB;EACrB,+HAA+H;AACjI;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,8BAA8B;UACtB,sBAAsB;EAC9B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,oGAAoG;EACpG,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,gJAAgJ;AAClJ;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,+HAA+H;AACjI;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wFAAwF;EACxF,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;EAClB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,uCAAuC;UAC/B,+BAA+B;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,+EAA+E;EAC/E,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;EACzD,mBAAmB;EACnB,qCAAqC;UAC7B,6BAA6B;AACvC;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;EACzD,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;EACzD,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;UAC/B,+BAA+B;EACvC,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;AACA;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;AACA;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;AACA;EACE,YAAY;AACd;AACA;;;;;EAKE,gBAAgB;EAChB,0BAA0B;EAC1B,mGAAmG;AACrG;AACA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,qBAAqB;EACrB,6CAA6C;EAC7C,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,wFAAwF;AAC1F;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".ag-theme-balham {\n  -webkit-font-smoothing: antialiased;\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 12px;\n  line-height: normal;\n}\n@font-face {\n  font-family: \"agGridBalham\";\n  src: url(\"data:application/font-woff;charset=utf-8;base64,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\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.ag-theme-balham .ag-icon {\n  font-family: \"agGridBalham\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.ag-theme-balham .ag-icon-aggregation::before {\n  content: \"\\f101\";\n}\n.ag-theme-balham .ag-icon-arrows::before {\n  content: \"\\f102\";\n}\n.ag-theme-balham .ag-icon-asc::before {\n  content: \"\\f103\";\n}\n.ag-theme-balham .ag-icon-cancel::before {\n  content: \"\\f104\";\n}\n.ag-theme-balham .ag-icon-chart::before {\n  content: \"\\f105\";\n}\n.ag-theme-balham .ag-icon-color-picker::before {\n  content: \"\\f109\";\n}\n.ag-theme-balham .ag-icon-columns::before {\n  content: \"\\f10a\";\n}\n.ag-theme-balham .ag-icon-contracted::before {\n  content: \"\\f10b\";\n}\n.ag-theme-balham .ag-icon-copy::before {\n  content: \"\\f10c\";\n}\n.ag-theme-balham .ag-icon-cross::before {\n  content: \"\\f10d\";\n}\n.ag-theme-balham .ag-icon-csv::before {\n  content: \"\\f10e\";\n}\n.ag-theme-balham .ag-icon-desc::before {\n  content: \"\\f10f\";\n}\n.ag-theme-balham .ag-icon-excel::before {\n  content: \"\\f110\";\n}\n.ag-theme-balham .ag-icon-expanded::before {\n  content: \"\\f111\";\n}\n.ag-theme-balham .ag-icon-eye-slash::before {\n  content: \"\\f112\";\n}\n.ag-theme-balham .ag-icon-eye::before {\n  content: \"\\f113\";\n}\n.ag-theme-balham .ag-icon-filter::before {\n  content: \"\\f114\";\n}\n.ag-theme-balham .ag-icon-first::before {\n  content: \"\\f115\";\n}\n.ag-theme-balham .ag-icon-grip::before {\n  content: \"\\f116\";\n}\n.ag-theme-balham .ag-icon-group::before {\n  content: \"\\f117\";\n}\n.ag-theme-balham .ag-icon-last::before {\n  content: \"\\f118\";\n}\n.ag-theme-balham .ag-icon-left::before {\n  content: \"\\f119\";\n}\n.ag-theme-balham .ag-icon-linked::before {\n  content: \"\\f11a\";\n}\n.ag-theme-balham .ag-icon-loading::before {\n  content: \"\\f11b\";\n}\n.ag-theme-balham .ag-icon-maximize::before {\n  content: \"\\f11c\";\n}\n.ag-theme-balham .ag-icon-menu::before {\n  content: \"\\f11d\";\n}\n.ag-theme-balham .ag-icon-minimize::before {\n  content: \"\\f11e\";\n}\n.ag-theme-balham .ag-icon-next::before {\n  content: \"\\f11f\";\n}\n.ag-theme-balham .ag-icon-none::before {\n  content: \"\\f120\";\n}\n.ag-theme-balham .ag-icon-not-allowed::before {\n  content: \"\\f121\";\n}\n.ag-theme-balham .ag-icon-paste::before {\n  content: \"\\f122\";\n}\n.ag-theme-balham .ag-icon-pin::before {\n  content: \"\\f123\";\n}\n.ag-theme-balham .ag-icon-pivot::before {\n  content: \"\\f124\";\n}\n.ag-theme-balham .ag-icon-previous::before {\n  content: \"\\f125\";\n}\n.ag-theme-balham .ag-icon-right::before {\n  content: \"\\f128\";\n}\n.ag-theme-balham .ag-icon-save::before {\n  content: \"\\f129\";\n}\n.ag-theme-balham .ag-icon-small-down::before {\n  content: \"\\f12a\";\n}\n.ag-theme-balham .ag-icon-small-left::before {\n  content: \"\\f12b\";\n}\n.ag-theme-balham .ag-icon-small-right::before {\n  content: \"\\f12c\";\n}\n.ag-theme-balham .ag-icon-small-up::before {\n  content: \"\\f12d\";\n}\n.ag-theme-balham .ag-icon-tick::before {\n  content: \"\\f12e\";\n}\n.ag-theme-balham .ag-icon-tree-closed::before {\n  content: \"\\f12f\";\n}\n.ag-theme-balham .ag-icon-tree-indeterminate::before {\n  content: \"\\f130\";\n}\n.ag-theme-balham .ag-icon-tree-open::before {\n  content: \"\\f131\";\n}\n.ag-theme-balham .ag-icon-unlinked::before {\n  content: \"\\f132\";\n}\n.ag-theme-balham .ag-icon-row-drag::before {\n  content: \"\\f116\";\n}\n.ag-theme-balham .ag-left-arrow::before {\n  content: \"\\f119\";\n}\n.ag-theme-balham .ag-right-arrow::before {\n  content: \"\\f128\";\n}\n.ag-theme-balham .ag-root-wrapper {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham [class^=ag-], .ag-theme-balham [class^=ag-]:focus, .ag-theme-balham [class^=ag-]:after, .ag-theme-balham [class^=ag-]:before {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n}\n.ag-theme-balham [class^=ag-]::-ms-clear {\n  display: none;\n}\n.ag-theme-balham .ag-checkbox .ag-input-wrapper,\n.ag-theme-balham .ag-radio-button .ag-input-wrapper {\n  overflow: visible;\n}\n.ag-theme-balham .ag-range-field .ag-input-wrapper {\n  height: 100%;\n}\n.ag-theme-balham .ag-toggle-button {\n  -webkit-box-flex: 0;\n          flex: none;\n  width: unset;\n  min-width: unset;\n}\n.ag-theme-balham .ag-ltr .ag-label-align-right .ag-label {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-label-align-right .ag-label {\n  margin-right: 4px;\n}\n\n.ag-theme-balham input[class^=ag-] {\n  margin: 0;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham textarea[class^=ag-],\n.ag-theme-balham select[class^=ag-] {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham input[class^=ag-]:not([type]),\n.ag-theme-balham input[class^=ag-][type=text],\n.ag-theme-balham input[class^=ag-][type=number],\n.ag-theme-balham input[class^=ag-][type=tel],\n.ag-theme-balham input[class^=ag-][type=date],\n.ag-theme-balham input[class^=ag-][type=datetime-local],\n.ag-theme-balham textarea[class^=ag-] {\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #95a5a6;\n  border-color: var(--ag-input-border-color, #95a5a6);\n}\n.ag-theme-balham input[class^=ag-]:not([type]):disabled,\n.ag-theme-balham input[class^=ag-][type=text]:disabled,\n.ag-theme-balham input[class^=ag-][type=number]:disabled,\n.ag-theme-balham input[class^=ag-][type=tel]:disabled,\n.ag-theme-balham input[class^=ag-][type=date]:disabled,\n.ag-theme-balham input[class^=ag-][type=datetime-local]:disabled,\n.ag-theme-balham textarea[class^=ag-]:disabled {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  background-color: #ebebeb;\n  background-color: var(--ag-input-disabled-background-color, #ebebeb);\n  border-color: rgba(149, 165, 166, 0.3);\n  border-color: var(--ag-input-disabled-border-color, rgba(149, 165, 166, 0.3));\n}\n.ag-theme-balham input[class^=ag-]:not([type]):focus,\n.ag-theme-balham input[class^=ag-][type=text]:focus,\n.ag-theme-balham input[class^=ag-][type=number]:focus,\n.ag-theme-balham input[class^=ag-][type=tel]:focus,\n.ag-theme-balham input[class^=ag-][type=date]:focus,\n.ag-theme-balham input[class^=ag-][type=datetime-local]:focus,\n.ag-theme-balham textarea[class^=ag-]:focus {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham input[class^=ag-]:not([type]):invalid,\n.ag-theme-balham input[class^=ag-][type=text]:invalid,\n.ag-theme-balham input[class^=ag-][type=number]:invalid,\n.ag-theme-balham input[class^=ag-][type=tel]:invalid,\n.ag-theme-balham input[class^=ag-][type=date]:invalid,\n.ag-theme-balham input[class^=ag-][type=datetime-local]:invalid,\n.ag-theme-balham textarea[class^=ag-]:invalid {\n  border-width: 2px;\n  border-style: solid;\n  border-color: #e02525;\n  border-color: var(--ag-input-border-color-invalid, var(--ag-invalid-color, #e02525));\n}\n.ag-theme-balham input[class^=ag-][type=number] {\n  -moz-appearance: textfield;\n}\n.ag-theme-balham input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-balham input[class^=ag-][type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ag-theme-balham input[class^=ag-][type=range] {\n  padding: 0;\n}\n.ag-theme-balham input[class^=ag-][type=button]:focus, .ag-theme-balham button[class^=ag-]:focus {\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n}\n.ag-theme-balham .ag-drag-handle {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-list-item, .ag-theme-balham .ag-virtual-list-item {\n  height: 24px;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-select-list {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.ag-theme-balham .ag-list-item {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-balham .ag-list-item.ag-active-item {\n  background-color: #ecf0f1;\n  background-color: var(--ag-row-hover-color, #ecf0f1);\n}\n.ag-theme-balham .ag-select-list-item {\n  padding-left: 4px;\n  padding-right: 4px;\n  cursor: default;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.ag-theme-balham .ag-select-list-item span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ag-theme-balham .ag-select .ag-picker-field-wrapper {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  min-height: 24px;\n  cursor: default;\n}\n.ag-theme-balham .ag-select.ag-disabled .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-balham .ag-select:not(.ag-cell-editor) {\n  height: 24px;\n}\n.ag-theme-balham .ag-select .ag-picker-field-display {\n  margin: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-balham .ag-select .ag-picker-field-icon {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-balham .ag-select.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-rich-select {\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n}\n.ag-theme-balham .ag-rich-select-list {\n  width: 100%;\n  min-width: 200px;\n  height: 182px;\n}\n.ag-theme-balham .ag-rich-select-value {\n  padding: 0 4px 0 12px;\n  height: 28px;\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-rich-select-virtual-list-item {\n  cursor: default;\n  height: 24px;\n}\n.ag-theme-balham .ag-rich-select-virtual-list-item:hover {\n  background-color: #ecf0f1;\n  background-color: var(--ag-row-hover-color, #ecf0f1);\n}\n.ag-theme-balham .ag-rich-select-row {\n  padding-left: 12px;\n}\n.ag-theme-balham .ag-rich-select-row-selected {\n  background-color: #b7e4ff;\n  background-color: var(--ag-selected-row-background-color, #b7e4ff);\n}\n.ag-theme-balham .ag-row-drag,\n.ag-theme-balham .ag-selection-checkbox,\n.ag-theme-balham .ag-group-expanded,\n.ag-theme-balham .ag-group-contracted {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-ltr .ag-row-drag, .ag-theme-balham .ag-ltr .ag-selection-checkbox, .ag-theme-balham .ag-ltr .ag-group-expanded, .ag-theme-balham .ag-ltr .ag-group-contracted {\n  margin-right: 12px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-drag, .ag-theme-balham .ag-rtl .ag-selection-checkbox, .ag-theme-balham .ag-rtl .ag-group-expanded, .ag-theme-balham .ag-rtl .ag-group-contracted {\n  margin-left: 12px;\n}\n\n.ag-theme-balham .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {\n  height: min(var(--ag-line-height, 26px), 26px);\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-balham .ag-group-expanded,\n.ag-theme-balham .ag-group-contracted {\n  cursor: pointer;\n}\n.ag-theme-balham .ag-group-title-bar-icon {\n  cursor: pointer;\n  -webkit-box-flex: 0;\n          flex: none;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-ltr .ag-group-child-count {\n  margin-left: 2px;\n}\n\n.ag-theme-balham .ag-rtl .ag-group-child-count {\n  margin-right: 2px;\n}\n\n.ag-theme-balham .ag-group-title-bar {\n  background-color: #e2e9eb;\n  background-color: var(--ag-subheader-background-color, #e2e9eb);\n  padding: 4px;\n}\n.ag-theme-balham .ag-group-toolbar {\n  padding: 4px;\n}\n.ag-theme-balham .ag-disabled-group-title-bar, .ag-theme-balham .ag-disabled-group-container {\n  opacity: 0.5;\n}\n.ag-theme-balham .group-item {\n  margin: 2px 0;\n}\n.ag-theme-balham .ag-label {\n  white-space: nowrap;\n}\n.ag-theme-balham .ag-ltr .ag-label {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-label {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-label-align-top .ag-label {\n  margin-bottom: 2px;\n}\n.ag-theme-balham .ag-ltr .ag-slider-field, .ag-theme-balham .ag-ltr .ag-angle-select-field {\n  margin-right: 8px;\n}\n\n.ag-theme-balham .ag-rtl .ag-slider-field, .ag-theme-balham .ag-rtl .ag-angle-select-field {\n  margin-left: 8px;\n}\n\n.ag-theme-balham .ag-angle-select-parent-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham .ag-angle-select-child-circle {\n  top: 4px;\n  left: 12px;\n  width: 6px;\n  height: 6px;\n  margin-left: -3px;\n  margin-top: -4px;\n  border-radius: 3px;\n  background-color: rgba(0, 0, 0, 0.54);\n  background-color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-picker-field-wrapper {\n  border: 1px solid;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  border-radius: 5px;\n}\n.ag-theme-balham .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n}\n.ag-theme-balham .ag-picker-field-button {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-dialog.ag-color-dialog {\n  border-radius: 5px;\n}\n.ag-theme-balham .ag-color-picker .ag-picker-field-display {\n  height: 16px;\n}\n.ag-theme-balham .ag-color-panel {\n  padding: 4px;\n}\n.ag-theme-balham .ag-spectrum-color {\n  background-color: rgb(255, 0, 0);\n  border-radius: 2px;\n}\n.ag-theme-balham .ag-spectrum-tools {\n  padding: 10px;\n}\n.ag-theme-balham .ag-spectrum-sat {\n  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));\n}\n.ag-theme-balham .ag-spectrum-val {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));\n}\n.ag-theme-balham .ag-spectrum-dragger {\n  border-radius: 12px;\n  height: 12px;\n  width: 12px;\n  border: 1px solid white;\n  background: black;\n  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n}\n.ag-theme-balham .ag-spectrum-hue-background {\n  border-radius: 2px;\n}\n.ag-theme-balham .ag-spectrum-alpha-background {\n  border-radius: 2px;\n}\n.ag-theme-balham .ag-spectrum-tool {\n  margin-bottom: 10px;\n  height: 11px;\n  border-radius: 2px;\n}\n.ag-theme-balham .ag-spectrum-slider {\n  margin-top: -12px;\n  width: 13px;\n  height: 13px;\n  border-radius: 13px;\n  background-color: rgb(248, 248, 248);\n  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.ag-theme-balham .ag-recent-color {\n  margin: 0 3px;\n}\n.ag-theme-balham .ag-recent-color:first-child {\n  margin-left: 0;\n}\n.ag-theme-balham .ag-recent-color:last-child {\n  margin-right: 0;\n}\n.ag-theme-balham.ag-dnd-ghost {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 32px !important;\n  line-height: 32px;\n  margin: 0;\n  padding: 0 8px;\n  -webkit-transform: translateY(8px);\n          transform: translateY(8px);\n}\n.ag-theme-balham .ag-dnd-ghost-icon {\n  margin-right: 4px;\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n}\n.ag-theme-balham .ag-popup-child:not(.ag-tooltip-custom) {\n  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);\n          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);\n}\n.ag-dragging-range-handle .ag-theme-balham .ag-dialog, .ag-dragging-fill-handle .ag-theme-balham .ag-dialog {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.ag-theme-balham .ag-dialog {\n  border-radius: 2px;\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-panel {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham .ag-panel-title-bar {\n  background-color: #f5f7f7;\n  background-color: var(--ag-header-background-color, #f5f7f7);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n  height: 32px;\n  padding: 4px 12px;\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-panel-title-bar-button {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-panel-title-bar-button {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-tooltip {\n  background-color: #f5f7f7;\n  background-color: var(--ag-header-background-color, #f5f7f7);\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n  padding: 4px;\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  border-radius: 2px;\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n  white-space: normal;\n}\n.ag-theme-balham .ag-tooltip.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-balham .ag-tooltip-custom {\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.ag-theme-balham .ag-tooltip-custom.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-balham .ag-ltr .ag-column-select-indent-1 {\n  padding-left: 20px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-1 {\n  padding-right: 20px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-2 {\n  padding-left: 40px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-2 {\n  padding-right: 40px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-3 {\n  padding-left: 60px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-3 {\n  padding-right: 60px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-4 {\n  padding-left: 80px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-4 {\n  padding-right: 80px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-5 {\n  padding-left: 100px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-5 {\n  padding-right: 100px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-6 {\n  padding-left: 120px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-6 {\n  padding-right: 120px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-7 {\n  padding-left: 140px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-7 {\n  padding-right: 140px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-8 {\n  padding-left: 160px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-8 {\n  padding-right: 160px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-select-indent-9 {\n  padding-left: 180px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-indent-9 {\n  padding-right: 180px;\n}\n\n.ag-theme-balham .ag-column-select-header-icon {\n  cursor: pointer;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-header-icon:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-header-icon:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-balham .ag-ltr .ag-column-select-column-label:not(:last-child) {\n  margin-right: 8px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-balham .ag-rtl .ag-column-select-column-label:not(:last-child) {\n  margin-left: 8px;\n}\n\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-column-select-column-group:not(:last-child),\n.ag-theme-balham .ag-column-select-column:not(:last-child) {\n  margin-bottom: 4px;\n}\n.ag-theme-balham .ag-column-select-column-readonly,\n.ag-theme-balham .ag-column-select-column-group-readonly {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  pointer-events: none;\n}\n.ag-theme-balham .ag-ltr .ag-column-select-add-group-indent {\n  margin-left: 24px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-select-add-group-indent {\n  margin-right: 24px;\n}\n\n.ag-theme-balham .ag-column-select-virtual-list-viewport {\n  padding: 3px 0px;\n}\n.ag-theme-balham .ag-column-select-virtual-list-item {\n  padding: 0 6px;\n}\n.ag-theme-balham .ag-rtl {\n  text-align: right;\n}\n.ag-theme-balham .ag-root-wrapper {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-left: 40px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-right: 40px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-1 {\n  padding-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-1 {\n  padding-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-left: 68px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-right: 68px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-2 {\n  padding-left: 56px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-2 {\n  padding-right: 56px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-left: 96px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-right: 96px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-3 {\n  padding-left: 84px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-3 {\n  padding-right: 84px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-left: 124px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-right: 124px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-4 {\n  padding-left: 112px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-4 {\n  padding-right: 112px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-left: 152px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-right: 152px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-5 {\n  padding-left: 140px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-5 {\n  padding-right: 140px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-left: 180px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-right: 180px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-6 {\n  padding-left: 168px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-6 {\n  padding-right: 168px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-left: 208px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-right: 208px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-7 {\n  padding-left: 196px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-7 {\n  padding-right: 196px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-left: 236px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-right: 236px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-8 {\n  padding-left: 224px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-8 {\n  padding-right: 224px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-left: 264px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-right: 264px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-9 {\n  padding-left: 252px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-9 {\n  padding-right: 252px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-left: 292px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-right: 292px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-10 {\n  padding-left: 280px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-10 {\n  padding-right: 280px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-left: 320px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-right: 320px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-11 {\n  padding-left: 308px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-11 {\n  padding-right: 308px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-left: 348px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-right: 348px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-12 {\n  padding-left: 336px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-12 {\n  padding-right: 336px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-left: 376px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-right: 376px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-13 {\n  padding-left: 364px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-13 {\n  padding-right: 364px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-left: 404px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-right: 404px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-14 {\n  padding-left: 392px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-14 {\n  padding-right: 392px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-left: 432px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-right: 432px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-15 {\n  padding-left: 420px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-15 {\n  padding-right: 420px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-left: 460px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-right: 460px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-16 {\n  padding-left: 448px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-16 {\n  padding-right: 448px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-left: 488px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-right: 488px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-17 {\n  padding-left: 476px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-17 {\n  padding-right: 476px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-left: 516px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-right: 516px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-18 {\n  padding-left: 504px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-18 {\n  padding-right: 504px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-left: 544px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-right: 544px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-19 {\n  padding-left: 532px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-19 {\n  padding-right: 532px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-left: 572px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-right: 572px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-20 {\n  padding-left: 560px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-20 {\n  padding-right: 560px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-left: 600px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-right: 600px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-21 {\n  padding-left: 588px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-21 {\n  padding-right: 588px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-left: 628px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-right: 628px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-22 {\n  padding-left: 616px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-22 {\n  padding-right: 616px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-left: 656px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-right: 656px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-23 {\n  padding-left: 644px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-23 {\n  padding-right: 644px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-left: 684px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-right: 684px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-24 {\n  padding-left: 672px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-24 {\n  padding-right: 672px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-left: 712px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-right: 712px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-25 {\n  padding-left: 700px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-25 {\n  padding-right: 700px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-left: 740px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-right: 740px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-26 {\n  padding-left: 728px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-26 {\n  padding-right: 728px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-left: 768px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-right: 768px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-27 {\n  padding-left: 756px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-27 {\n  padding-right: 756px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-left: 796px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-right: 796px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-28 {\n  padding-left: 784px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-28 {\n  padding-right: 784px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-left: 824px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-right: 824px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-29 {\n  padding-left: 812px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-29 {\n  padding-right: 812px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-left: 852px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-right: 852px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-30 {\n  padding-left: 840px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-30 {\n  padding-right: 840px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-left: 880px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-right: 880px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-31 {\n  padding-left: 868px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-31 {\n  padding-right: 868px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-left: 908px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-right: 908px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-32 {\n  padding-left: 896px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-32 {\n  padding-right: 896px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-left: 936px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-right: 936px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-33 {\n  padding-left: 924px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-33 {\n  padding-right: 924px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-left: 964px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-right: 964px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-34 {\n  padding-left: 952px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-34 {\n  padding-right: 952px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-left: 992px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-right: 992px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-35 {\n  padding-left: 980px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-35 {\n  padding-right: 980px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-left: 1020px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-right: 1020px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-36 {\n  padding-left: 1008px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-36 {\n  padding-right: 1008px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-left: 1048px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-right: 1048px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-37 {\n  padding-left: 1036px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-37 {\n  padding-right: 1036px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-left: 1076px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-right: 1076px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-38 {\n  padding-left: 1064px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-38 {\n  padding-right: 1064px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-left: 1104px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-right: 1104px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-39 {\n  padding-left: 1092px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-39 {\n  padding-right: 1092px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-left: 1132px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-right: 1132px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-40 {\n  padding-left: 1120px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-40 {\n  padding-right: 1120px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-left: 1160px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-right: 1160px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-41 {\n  padding-left: 1148px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-41 {\n  padding-right: 1148px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-left: 1188px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-right: 1188px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-42 {\n  padding-left: 1176px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-42 {\n  padding-right: 1176px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-left: 1216px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-right: 1216px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-43 {\n  padding-left: 1204px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-43 {\n  padding-right: 1204px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-left: 1244px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-right: 1244px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-44 {\n  padding-left: 1232px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-44 {\n  padding-right: 1232px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-left: 1272px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-right: 1272px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-45 {\n  padding-left: 1260px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-45 {\n  padding-right: 1260px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-left: 1300px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-right: 1300px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-46 {\n  padding-left: 1288px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-46 {\n  padding-right: 1288px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-left: 1328px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-right: 1328px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-47 {\n  padding-left: 1316px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-47 {\n  padding-right: 1316px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-left: 1356px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-right: 1356px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-48 {\n  padding-left: 1344px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-48 {\n  padding-right: 1344px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-left: 1384px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-right: 1384px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-49 {\n  padding-left: 1372px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-49 {\n  padding-right: 1372px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-left: 1412px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-right: 1412px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-50 {\n  padding-left: 1400px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-50 {\n  padding-right: 1400px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-left: 1440px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-right: 1440px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-51 {\n  padding-left: 1428px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-51 {\n  padding-right: 1428px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-left: 1468px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-right: 1468px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-52 {\n  padding-left: 1456px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-52 {\n  padding-right: 1456px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-left: 1496px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-right: 1496px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-53 {\n  padding-left: 1484px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-53 {\n  padding-right: 1484px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-left: 1524px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-right: 1524px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-54 {\n  padding-left: 1512px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-54 {\n  padding-right: 1512px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-left: 1552px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-right: 1552px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-55 {\n  padding-left: 1540px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-55 {\n  padding-right: 1540px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-left: 1580px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-right: 1580px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-56 {\n  padding-left: 1568px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-56 {\n  padding-right: 1568px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-left: 1608px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-right: 1608px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-57 {\n  padding-left: 1596px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-57 {\n  padding-right: 1596px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-left: 1636px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-right: 1636px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-58 {\n  padding-left: 1624px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-58 {\n  padding-right: 1624px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-left: 1664px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-right: 1664px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-59 {\n  padding-left: 1652px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-59 {\n  padding-right: 1652px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-left: 1692px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-right: 1692px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-60 {\n  padding-left: 1680px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-60 {\n  padding-right: 1680px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-left: 1720px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-right: 1720px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-61 {\n  padding-left: 1708px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-61 {\n  padding-right: 1708px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-left: 1748px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-right: 1748px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-62 {\n  padding-left: 1736px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-62 {\n  padding-right: 1736px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-left: 1776px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-right: 1776px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-63 {\n  padding-left: 1764px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-63 {\n  padding-right: 1764px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-left: 1804px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-right: 1804px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-64 {\n  padding-left: 1792px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-64 {\n  padding-right: 1792px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-left: 1832px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-right: 1832px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-65 {\n  padding-left: 1820px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-65 {\n  padding-right: 1820px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-left: 1860px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-right: 1860px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-66 {\n  padding-left: 1848px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-66 {\n  padding-right: 1848px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-left: 1888px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-right: 1888px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-67 {\n  padding-left: 1876px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-67 {\n  padding-right: 1876px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-left: 1916px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-right: 1916px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-68 {\n  padding-left: 1904px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-68 {\n  padding-right: 1904px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-left: 1944px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-right: 1944px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-69 {\n  padding-left: 1932px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-69 {\n  padding-right: 1932px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-left: 1972px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-right: 1972px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-70 {\n  padding-left: 1960px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-70 {\n  padding-right: 1960px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-left: 2000px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-right: 2000px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-71 {\n  padding-left: 1988px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-71 {\n  padding-right: 1988px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-left: 2028px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-right: 2028px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-72 {\n  padding-left: 2016px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-72 {\n  padding-right: 2016px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-left: 2056px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-right: 2056px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-73 {\n  padding-left: 2044px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-73 {\n  padding-right: 2044px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-left: 2084px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-right: 2084px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-74 {\n  padding-left: 2072px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-74 {\n  padding-right: 2072px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-left: 2112px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-right: 2112px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-75 {\n  padding-left: 2100px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-75 {\n  padding-right: 2100px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-left: 2140px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-right: 2140px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-76 {\n  padding-left: 2128px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-76 {\n  padding-right: 2128px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-left: 2168px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-right: 2168px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-77 {\n  padding-left: 2156px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-77 {\n  padding-right: 2156px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-left: 2196px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-right: 2196px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-78 {\n  padding-left: 2184px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-78 {\n  padding-right: 2184px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-left: 2224px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-right: 2224px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-79 {\n  padding-left: 2212px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-79 {\n  padding-right: 2212px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-left: 2252px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-right: 2252px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-80 {\n  padding-left: 2240px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-80 {\n  padding-right: 2240px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-left: 2280px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-right: 2280px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-81 {\n  padding-left: 2268px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-81 {\n  padding-right: 2268px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-left: 2308px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-right: 2308px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-82 {\n  padding-left: 2296px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-82 {\n  padding-right: 2296px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-left: 2336px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-right: 2336px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-83 {\n  padding-left: 2324px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-83 {\n  padding-right: 2324px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-left: 2364px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-right: 2364px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-84 {\n  padding-left: 2352px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-84 {\n  padding-right: 2352px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-left: 2392px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-right: 2392px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-85 {\n  padding-left: 2380px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-85 {\n  padding-right: 2380px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-left: 2420px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-right: 2420px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-86 {\n  padding-left: 2408px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-86 {\n  padding-right: 2408px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-left: 2448px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-right: 2448px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-87 {\n  padding-left: 2436px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-87 {\n  padding-right: 2436px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-left: 2476px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-right: 2476px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-88 {\n  padding-left: 2464px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-88 {\n  padding-right: 2464px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-left: 2504px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-right: 2504px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-89 {\n  padding-left: 2492px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-89 {\n  padding-right: 2492px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-left: 2532px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-right: 2532px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-90 {\n  padding-left: 2520px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-90 {\n  padding-right: 2520px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-left: 2560px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-right: 2560px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-91 {\n  padding-left: 2548px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-91 {\n  padding-right: 2548px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-left: 2588px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-right: 2588px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-92 {\n  padding-left: 2576px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-92 {\n  padding-right: 2576px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-left: 2616px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-right: 2616px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-93 {\n  padding-left: 2604px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-93 {\n  padding-right: 2604px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-left: 2644px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-right: 2644px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-94 {\n  padding-left: 2632px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-94 {\n  padding-right: 2632px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-left: 2672px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-right: 2672px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-95 {\n  padding-left: 2660px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-95 {\n  padding-right: 2660px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-left: 2700px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-right: 2700px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-96 {\n  padding-left: 2688px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-96 {\n  padding-right: 2688px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-left: 2728px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-right: 2728px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-97 {\n  padding-left: 2716px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-97 {\n  padding-right: 2716px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-left: 2756px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-right: 2756px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-98 {\n  padding-left: 2744px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-98 {\n  padding-right: 2744px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-left: 2784px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-right: 2784px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-indent-99 {\n  padding-left: 2772px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-indent-99 {\n  padding-right: 2772px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {\n  margin-left: 28px;\n}\n\n.ag-theme-balham .ag-rtl .ag-row-group-leaf-indent {\n  margin-right: 28px;\n}\n\n.ag-theme-balham .ag-value-change-delta {\n  padding-right: 2px;\n}\n.ag-theme-balham .ag-value-change-delta-up {\n  color: #43a047;\n  color: var(--ag-value-change-delta-up-color, #43a047);\n}\n.ag-theme-balham .ag-value-change-delta-down {\n  color: #e53935;\n  color: var(--ag-value-change-delta-down-color, #e53935);\n}\n.ag-theme-balham .ag-value-change-value {\n  background-color: transparent;\n  border-radius: 1px;\n  padding-left: 1px;\n  padding-right: 1px;\n  -webkit-transition: background-color 1s;\n  transition: background-color 1s;\n}\n.ag-theme-balham .ag-value-change-value-highlight {\n  background-color: rgba(22, 160, 133, 0.5);\n  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5));\n  -webkit-transition: background-color 0.1s;\n  transition: background-color 0.1s;\n}\n.ag-theme-balham .ag-cell-data-changed {\n  background-color: rgba(22, 160, 133, 0.5) !important;\n  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5)) !important;\n}\n.ag-theme-balham .ag-cell-data-changed-animation {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-cell-highlight {\n  background-color: #0091ea !important;\n  background-color: var(--ag-range-selection-highlight-color, var(--ag-balham-active-color, #0091ea)) !important;\n}\n.ag-theme-balham .ag-row {\n  height: 28px;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  color: #000;\n  color: var(--ag-data-color, var(--ag-foreground-color, #000));\n  border-width: 1px;\n  border-color: #d9dcde;\n  border-color: var(--ag-row-border-color, #d9dcde);\n  border-bottom-style: solid;\n}\n.ag-theme-balham .ag-row-highlight-above::after, .ag-theme-balham .ag-row-highlight-below::after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 1px);\n  height: 1px;\n  background-color: #0091ea;\n  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n  left: 1px;\n}\n.ag-theme-balham .ag-row-highlight-above::after {\n  top: -1px;\n}\n.ag-theme-balham .ag-row-highlight-above.ag-row-first::after {\n  top: 0;\n}\n.ag-theme-balham .ag-row-highlight-below::after {\n  bottom: 0px;\n}\n.ag-theme-balham .ag-row-odd {\n  background-color: #fcfdfe;\n  background-color: var(--ag-odd-row-background-color, #fcfdfe);\n}\n.ag-theme-balham .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-row-hover {\n  background-color: #ecf0f1;\n  background-color: var(--ag-row-hover-color, #ecf0f1);\n}\n.ag-theme-balham .ag-column-hover {\n  background-color: #ecf0f1;\n  background-color: var(--ag-column-hover-color, #ecf0f1);\n}\n.ag-theme-balham .ag-ltr .ag-right-aligned-cell {\n  text-align: right;\n}\n\n.ag-theme-balham .ag-rtl .ag-right-aligned-cell {\n  text-align: left;\n}\n\n.ag-theme-balham .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-balham .ag-ltr .ag-right-aligned-cell .ag-group-value {\n  margin-left: auto;\n}\n\n.ag-theme-balham .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-balham .ag-rtl .ag-right-aligned-cell .ag-group-value {\n  margin-right: auto;\n}\n\n.ag-theme-balham .ag-cell, .ag-theme-balham .ag-full-width-row .ag-cell-wrapper.ag-row-group {\n  border: 1px solid transparent;\n  line-height: min(var(--ag-line-height, 26px), 26px);\n  padding-left: 11px;\n  padding-right: 11px;\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n.ag-theme-balham .ag-row > .ag-cell-wrapper {\n  padding-left: 11px;\n  padding-right: 11px;\n}\n.ag-theme-balham .ag-row-dragging {\n  cursor: move;\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-cell-inline-editing {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n  padding: 0;\n  height: 28px;\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n}\n.ag-theme-balham .ag-popup-editor {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n  padding: 0;\n}\n.ag-theme-balham .ag-large-text-input {\n  height: auto;\n  padding: 12px;\n}\n.ag-theme-balham .ag-details-row {\n  padding: 20px;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n}\n.ag-theme-balham .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-balham .ag-layout-auto-height .ag-center-cols-container, .ag-theme-balham .ag-layout-print .ag-center-cols-clipper, .ag-theme-balham .ag-layout-print .ag-center-cols-container {\n  min-height: 50px;\n}\n.ag-theme-balham .ag-overlay-loading-wrapper {\n  background-color: rgba(255, 255, 255, 0.66);\n  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));\n}\n.ag-theme-balham .ag-overlay-loading-center {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n}\n.ag-theme-balham .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n  padding-top: 30px;\n}\n.ag-theme-balham .ag-loading {\n  padding-left: 12px;\n  display: -webkit-box;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-balham .ag-loading-icon {\n  padding-right: 12px;\n}\n.ag-theme-balham .ag-icon-loading {\n  -webkit-animation-name: spin;\n          animation-name: spin;\n  -webkit-animation-duration: 1000ms;\n          animation-duration: 1000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.ag-theme-balham .ag-floating-top {\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-floating-bottom {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-cell {\n  border-right: solid transparent;\n}\n\n.ag-theme-balham .ag-rtl .ag-cell {\n  border-left: solid transparent;\n}\n\n.ag-theme-balham .ag-ltr .ag-cell {\n  border-right-width: 1px;\n}\n\n.ag-theme-balham .ag-rtl .ag-cell {\n  border-left-width: 1px;\n}\n\n.ag-theme-balham .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-row-selected {\n  background-color: #b7e4ff;\n  background-color: var(--ag-selected-row-background-color, #b7e4ff);\n}\n.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus),\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {\n  background-color: rgba(0, 145, 234, 0.2);\n  background-color: var(--ag-range-selection-background-color, rgba(0, 145, 234, 0.2));\n}\n.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {\n  background-color: rgba(0, 88, 255, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;\n}\n.ag-theme-balham .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {\n  background-color: rgba(0, 255, 132, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;\n}\n.ag-theme-balham .ag-cell-range-selected-1:not(.ag-cell-focus),\n.ag-theme-balham .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {\n  background-color: rgba(0, 145, 234, 0.2);\n  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(0, 145, 234, 0.2)));\n}\n.ag-theme-balham .ag-cell-range-selected-2:not(.ag-cell-focus),\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {\n  background-color: rgba(0, 145, 234, 0.36);\n  background-color: var(--ag-range-selection-background-color-2, rgba(0, 145, 234, 0.36));\n}\n.ag-theme-balham .ag-cell-range-selected-3:not(.ag-cell-focus),\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {\n  background-color: rgba(0, 145, 234, 0.488);\n  background-color: var(--ag-range-selection-background-color-3, rgba(0, 145, 234, 0.488));\n}\n.ag-theme-balham .ag-cell-range-selected-4:not(.ag-cell-focus),\n.ag-theme-balham .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {\n  background-color: rgba(0, 145, 234, 0.5904);\n  background-color: var(--ag-range-selection-background-color-4, rgba(0, 145, 234, 0.5904));\n}\n.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {\n  border-top-color: #0091ea;\n  border-top-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {\n  border-right-color: #0091ea;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {\n  border-bottom-color: #0091ea;\n  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {\n  border-left-color: #0091ea;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-balham .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-balham .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-balham .ag-ltr .ag-cell-range-single-cell,\n.ag-theme-balham .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-balham .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-balham .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-balham .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-balham .ag-rtl .ag-cell-range-single-cell,\n.ag-theme-balham .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {\n  border: 1px solid;\n  border-color: #0091ea;\n  border-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n  outline: initial;\n}\n.ag-theme-balham .ag-cell.ag-selection-fill-top,\n.ag-theme-balham .ag-cell.ag-selection-fill-top.ag-cell-range-selected {\n  border-top: 1px dashed;\n  border-top-color: #0091ea;\n  border-top-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #0091ea;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n\n.ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #0091ea;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n\n.ag-theme-balham .ag-cell.ag-selection-fill-bottom,\n.ag-theme-balham .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {\n  border-bottom: 1px dashed;\n  border-bottom-color: #0091ea;\n  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-balham .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #0091ea;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n\n.ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-balham .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #0091ea;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n\n.ag-theme-balham .ag-range-handle, .ag-theme-balham .ag-fill-handle {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  bottom: -1px;\n  background-color: #0091ea;\n  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-ltr .ag-range-handle, .ag-theme-balham .ag-ltr .ag-fill-handle {\n  right: -1px;\n}\n\n.ag-theme-balham .ag-rtl .ag-range-handle, .ag-theme-balham .ag-rtl .ag-fill-handle {\n  left: -1px;\n}\n\n.ag-theme-balham .ag-fill-handle {\n  cursor: cell;\n}\n.ag-theme-balham .ag-range-handle {\n  cursor: nwse-resize;\n}\n.ag-theme-balham .ag-cell-inline-editing {\n  border-color: #719ECE !important;\n  border-color: var(--ag-input-focus-border-color, #719ECE) !important;\n}\n.ag-theme-balham .ag-menu {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n  padding: 0;\n}\n.ag-theme-balham .ag-menu-list {\n  cursor: default;\n  padding: 4px 0;\n}\n.ag-theme-balham .ag-menu-separator {\n  height: 9px;\n}\n.ag-theme-balham .ag-menu-separator-part::after {\n  content: \"\";\n  display: block;\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-menu-option-active, .ag-theme-balham .ag-compact-menu-option-active {\n  background-color: #ecf0f1;\n  background-color: var(--ag-row-hover-color, #ecf0f1);\n}\n.ag-theme-balham .ag-menu-option-part, .ag-theme-balham .ag-compact-menu-option-part {\n  line-height: 16px;\n  padding: 6px 0;\n}\n.ag-theme-balham .ag-menu-option-disabled, .ag-theme-balham .ag-compact-menu-option-disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-menu-option-icon, .ag-theme-balham .ag-compact-menu-option-icon {\n  width: 16px;\n}\n.ag-theme-balham .ag-ltr .ag-menu-option-icon, .ag-theme-balham .ag-ltr .ag-compact-menu-option-icon {\n  padding-left: 8px;\n}\n\n.ag-theme-balham .ag-rtl .ag-menu-option-icon, .ag-theme-balham .ag-rtl .ag-compact-menu-option-icon {\n  padding-right: 8px;\n}\n\n.ag-theme-balham .ag-menu-option-text, .ag-theme-balham .ag-compact-menu-option-text {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ag-theme-balham .ag-ltr .ag-menu-option-shortcut, .ag-theme-balham .ag-ltr .ag-compact-menu-option-shortcut {\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-menu-option-shortcut, .ag-theme-balham .ag-rtl .ag-compact-menu-option-shortcut {\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-menu-option-popup-pointer, .ag-theme-balham .ag-compact-menu-option-popup-pointer {\n  padding-right: 4px;\n}\n.ag-theme-balham .ag-tabs {\n  min-width: 220px;\n}\n.ag-theme-balham .ag-tabs-header {\n  width: 100%;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-balham .ag-tab {\n  border-bottom: 0 solid transparent;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-flex: 0;\n          flex: none;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  cursor: pointer;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-tab:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-tab:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-tab-selected {\n  border-bottom-color: #0091ea;\n  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-menu-header {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-filter-separator {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-menu:not(.ag-tabs) .ag-filter-select {\n  min-width: 167px;\n}\n.ag-theme-balham .ag-tabs .ag-filter-select {\n  min-width: 206px;\n}\n.ag-theme-balham .ag-filter-select .ag-picker-field-wrapper {\n  width: 0;\n}\n.ag-theme-balham .ag-filter-condition-operator {\n  height: 17px;\n}\n.ag-theme-balham .ag-ltr .ag-filter-condition-operator-or {\n  margin-left: 8px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-condition-operator-or {\n  margin-right: 8px;\n}\n\n.ag-theme-balham .ag-set-filter-select-all {\n  padding-top: 6px;\n}\n.ag-theme-balham .ag-set-filter-list, .ag-theme-balham .ag-filter-no-matches {\n  height: 144px;\n}\n.ag-theme-balham .ag-set-filter-filter {\n  margin-top: 6px;\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.ag-theme-balham .ag-filter-to {\n  margin-top: 4px;\n}\n.ag-theme-balham .ag-mini-filter {\n  margin: 6px 6px;\n}\n.ag-theme-balham .ag-set-filter-item {\n  margin: 0px 6px;\n}\n.ag-theme-balham .ag-ltr .ag-set-filter-item-value {\n  margin-left: 6px;\n}\n\n.ag-theme-balham .ag-rtl .ag-set-filter-item-value {\n  margin-right: 6px;\n}\n\n.ag-theme-balham .ag-filter-apply-panel {\n  padding: 6px 6px;\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-filter-apply-panel-button {\n  line-height: 1.5;\n}\n.ag-theme-balham .ag-ltr .ag-filter-apply-panel-button {\n  margin-left: 8px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-apply-panel-button {\n  margin-right: 8px;\n}\n\n.ag-theme-balham .ag-simple-filter-body-wrapper {\n  padding: 6px 6px;\n  padding-bottom: 2px;\n}\n.ag-theme-balham .ag-simple-filter-body-wrapper > * {\n  margin-bottom: 4px;\n}\n.ag-theme-balham .ag-filter-no-matches {\n  padding: 6px 6px;\n}\n.ag-theme-balham .ag-multi-filter-menu-item {\n  margin: 4px 0;\n}\n.ag-theme-balham .ag-multi-filter-group-title-bar {\n  padding: 8px 4px;\n  background-color: transparent;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-side-bar {\n  position: relative;\n}\n.ag-theme-balham .ag-tool-panel-wrapper {\n  width: 200px;\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n}\n.ag-theme-balham .ag-side-buttons {\n  padding-top: 16px;\n  width: 20px;\n  position: relative;\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n  overflow: hidden;\n}\n.ag-theme-balham button.ag-side-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  background: transparent;\n  padding: 8px 0 8px 0;\n  width: calc(100% + 1px);\n  margin: 0;\n  min-height: 72px;\n  background-position-y: center;\n  background-position-x: center;\n  background-repeat: no-repeat;\n  border: none;\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham button.ag-side-button-button:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-side-button-button:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-side-button-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-selected .ag-side-button-button {\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-side-button-icon-wrapper {\n  margin-bottom: 3px;\n}\n.ag-theme-balham .ag-ltr .ag-side-bar-left,\n.ag-theme-balham .ag-rtl .ag-side-bar-right {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-side-button-button,\n.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-side-button-button {\n  border-right: 0 solid transparent;\n  margin-right: -1px;\n  padding-right: 1px;\n}\n.ag-theme-balham .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-balham .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-right-color: #0091ea;\n  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-rtl .ag-side-bar-left,\n.ag-theme-balham .ag-ltr .ag-side-bar-right {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-side-button-button,\n.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-side-button-button {\n  border-left: 0 solid transparent;\n  margin-left: -1px;\n  padding-left: 1px;\n}\n.ag-theme-balham .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-balham .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-left-color: #0091ea;\n  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-filter-toolpanel-header {\n  height: 24px;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-header, .ag-theme-balham .ag-ltr .ag-filter-toolpanel-search {\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-header, .ag-theme-balham .ag-rtl .ag-filter-toolpanel-search {\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-keyboard-focus .ag-filter-toolpanel-header:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  font-family: \"agGridBalham\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f114\";\n  position: absolute;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-0-header {\n  height: 32px;\n}\n.ag-theme-balham .ag-filter-toolpanel-group-item {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n.ag-theme-balham .ag-filter-toolpanel-search {\n  height: 32px;\n}\n.ag-theme-balham .ag-filter-toolpanel-search-input {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  height: 16px;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-search-input {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-search-input {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-0 {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-left: 20px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-right: 20px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-left: 36px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-right: 36px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-left: 52px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-right: 52px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-left: 68px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-right: 68px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-left: 84px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-right: 84px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-left: 100px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-right: 100px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-left: 116px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-right: 116px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-left: 132px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-right: 132px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-left: 148px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-right: 148px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-left: 164px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-right: 164px;\n}\n\n.ag-theme-balham .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {\n  padding-left: 4px;\n}\n.ag-theme-balham .ag-filter-toolpanel-instance-filter {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n  margin-top: 4px;\n}\n.ag-theme-balham .ag-ltr .ag-filter-toolpanel-instance-header-icon {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-filter-toolpanel-instance-header-icon {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-pivot-mode-panel {\n  min-height: 32px;\n  height: 32px;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-balham .ag-pivot-mode-select {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-balham .ag-ltr .ag-pivot-mode-select {\n  margin-left: 6px;\n}\n\n.ag-theme-balham .ag-rtl .ag-pivot-mode-select {\n  margin-right: 6px;\n}\n\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-header:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-select-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-column-select-header {\n  height: 32px;\n  -webkit-box-align: center;\n          align-items: center;\n  padding: 0 6px;\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-column-panel-column-select {\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-column-group-icons,\n.ag-theme-balham .ag-column-select-header-icon {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-column-select-list .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #0091ea;\n  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-column-select-list .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-balham .ag-column-select-list .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-balham .ag-header {\n  background-color: #f5f7f7;\n  background-color: var(--ag-header-background-color, #f5f7f7);\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-header-row {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n  height: 32px;\n}\n.ag-theme-balham .ag-pinned-right-header {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-pinned-left-header {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-left: 4px;\n}\n\n.ag-theme-balham .ag-header-cell,\n.ag-theme-balham .ag-header-group-cell {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.ag-theme-balham .ag-header-cell.ag-header-cell-moving,\n.ag-theme-balham .ag-header-group-cell.ag-header-cell-moving {\n  background-color: white;\n  background-color: var(--ag-header-cell-moving-background-color, var(--ag-background-color, white));\n}\n.ag-theme-balham .ag-keyboard-focus .ag-header-cell:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-header-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-keyboard-focus .ag-header-group-cell:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-header-group-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-header-icon {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-header-expand-icon {\n  cursor: pointer;\n}\n.ag-theme-balham .ag-ltr .ag-header-expand-icon {\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-header-expand-icon {\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-header-row:not(:first-child) .ag-header-cell,\n.ag-theme-balham .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-header-cell::after,\n.ag-theme-balham .ag-header-group-cell::after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  display: block;\n  width: 1px;\n  height: 50%;\n  top: calc(50% - 25%);\n  background-color: rgba(189, 195, 199, 0.5);\n  background-color: var(--ag-header-column-separator-color, rgba(189, 195, 199, 0.5));\n}\n.ag-theme-balham .ag-ltr .ag-header-cell::after, .ag-theme-balham .ag-ltr .ag-header-group-cell::after {\n  right: 0;\n}\n\n.ag-theme-balham .ag-rtl .ag-header-cell::after, .ag-theme-balham .ag-rtl .ag-header-group-cell::after {\n  left: 0;\n}\n\n.ag-theme-balham .ag-ltr .ag-header-select-all {\n  margin-right: 12px;\n}\n\n.ag-theme-balham .ag-rtl .ag-header-select-all {\n  margin-left: 12px;\n}\n\n.ag-theme-balham .ag-ltr .ag-floating-filter-button {\n  margin-left: 12px;\n}\n\n.ag-theme-balham .ag-rtl .ag-floating-filter-button {\n  margin-right: 12px;\n}\n\n.ag-theme-balham .ag-floating-filter-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background: transparent;\n  border: none;\n  height: 16px;\n  padding: 0;\n  width: 16px;\n}\n.ag-theme-balham .ag-filter-loading {\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n  height: 100%;\n  padding: 6px 6px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.ag-theme-balham .ag-paging-panel {\n  border-top: 1px solid;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 32px;\n}\n.ag-theme-balham .ag-paging-panel > * {\n  margin: 0 12px;\n}\n.ag-theme-balham .ag-paging-button {\n  cursor: pointer;\n}\n.ag-theme-balham .ag-paging-button.ag-disabled {\n  cursor: default;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-balham .ag-keyboard-focus .ag-paging-button:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-paging-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-paging-button, .ag-theme-balham .ag-paging-description {\n  margin: 0 4px;\n}\n.ag-theme-balham .ag-status-bar {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-border-color, #bdc3c7);\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  padding-right: 16px;\n  padding-left: 16px;\n  line-height: 1.5;\n}\n.ag-theme-balham .ag-status-name-value-value {\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n}\n.ag-theme-balham .ag-status-bar-center {\n  text-align: center;\n}\n.ag-theme-balham .ag-status-name-value {\n  margin-left: 4px;\n  margin-right: 4px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.ag-theme-balham .ag-column-drop-cell {\n  background: #dddede;\n  background: var(--ag-chip-background-color, #dddede);\n  border-radius: 16px;\n  height: 16px;\n  padding: 0 2px;\n  border: 1px solid transparent;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-drop-cell:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-column-drop-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 2px;\n  left: 2px;\n  display: block;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-column-drop-cell-text {\n  margin: 0 4px;\n}\n.ag-theme-balham .ag-column-drop-cell-button {\n  min-width: 16px;\n  margin: 0 2px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-column-drop-cell-drag-handle {\n  margin-left: 8px;\n}\n.ag-theme-balham .ag-column-drop-cell-ghost {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-column-drop-horizontal {\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 28px;\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-ltr .ag-column-drop-horizontal {\n  padding-left: 12px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-drop-horizontal {\n  padding-right: 12px;\n}\n\n.ag-theme-balham .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n\n.ag-theme-balham .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n\n.ag-theme-balham .ag-column-drop-horizontal-cell-separator {\n  margin: 0 4px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-column-drop-horizontal-empty-message {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-balham .ag-ltr .ag-column-drop-horizontal-icon {\n  margin-right: 12px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-drop-horizontal-icon {\n  margin-left: 12px;\n}\n\n.ag-theme-balham .ag-column-drop-vertical-list {\n  padding-bottom: 4px;\n  padding-right: 4px;\n  padding-left: 4px;\n}\n.ag-theme-balham .ag-column-drop-vertical-cell {\n  margin-top: 4px;\n}\n.ag-theme-balham .ag-column-drop-vertical {\n  min-height: 50px;\n  border-bottom: solid 1px;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-column-drop-vertical.ag-last-column-drop {\n  border-bottom: none;\n}\n.ag-theme-balham .ag-column-drop-vertical-icon {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.ag-theme-balham .ag-column-drop-vertical-empty-message {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  margin-top: 4px;\n}\n.ag-theme-balham .ag-select-agg-func-popup {\n  border: solid 1px;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  background: white;\n  background: var(--ag-background-color, white);\n  border-radius: 2px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding: 4px;\n  background: white;\n  background: var(--ag-background-color, white);\n  height: 70px;\n  padding: 0;\n}\n.ag-theme-balham .ag-select-agg-func-virtual-list-item {\n  cursor: default;\n  padding-left: 8px;\n}\n.ag-theme-balham .ag-select-agg-func-virtual-list-item:hover {\n  background-color: #b7e4ff;\n  background-color: var(--ag-selected-row-background-color, #b7e4ff);\n}\n.ag-theme-balham .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-balham .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: #719ECE;\n  border-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham .ag-chart-menu {\n  border-radius: 2px;\n  background: white;\n  background: var(--ag-background-color, white);\n}\n.ag-theme-balham .ag-chart-menu-icon {\n  opacity: 0.5;\n  line-height: 24px;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  margin: 2px 0;\n  cursor: pointer;\n  border-radius: 2px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-chart-menu-icon:hover {\n  opacity: 1;\n}\n.ag-theme-balham .ag-chart-mini-thumbnail {\n  border: 1px solid;\n  border-color: #bdc3c7;\n  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n  border-radius: 5px;\n  margin: 5px;\n}\n.ag-theme-balham .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-balham .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {\n  margin-left: auto;\n  margin-right: auto;\n}\n.ag-theme-balham .ag-ltr .ag-chart-mini-thumbnail:first-child {\n  margin-left: 0;\n}\n\n.ag-theme-balham .ag-rtl .ag-chart-mini-thumbnail:first-child {\n  margin-right: 0;\n}\n\n.ag-theme-balham .ag-ltr .ag-chart-mini-thumbnail:last-child {\n  margin-right: 0;\n}\n\n.ag-theme-balham .ag-rtl .ag-chart-mini-thumbnail:last-child {\n  margin-left: 0;\n}\n\n.ag-theme-balham .ag-chart-mini-thumbnail.ag-selected {\n  border-color: #0091ea;\n  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-chart-settings-card-item {\n  background: #000;\n  background: var(--ag-foreground-color, #000);\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n.ag-theme-balham .ag-chart-settings-card-item.ag-selected {\n  background-color: #0091ea;\n  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-chart-data-column-drag-handle {\n  margin-left: 4px;\n}\n.ag-theme-balham .ag-charts-settings-group-title-bar,\n.ag-theme-balham .ag-charts-data-group-title-bar,\n.ag-theme-balham .ag-charts-format-top-level-group-title-bar {\n  border-top: solid 1px;\n  border-top-color: #bdc3c7;\n  border-top-color: var(--ag-secondary-border-color, var(--ag-border-color, #bdc3c7));\n}\n.ag-theme-balham .ag-charts-settings-group-container {\n  padding: 4px;\n}\n.ag-theme-balham .ag-charts-data-group-container {\n  padding: 3px 6px;\n}\n.ag-theme-balham .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {\n  height: 24px;\n}\n.ag-theme-balham .ag-charts-data-group-container .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #0091ea;\n  background-color: var(--ag-range-selection-border-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham .ag-charts-data-group-container .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-balham .ag-charts-data-group-container .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-balham .ag-charts-format-top-level-group-container {\n  margin-left: 8px;\n  padding: 4px;\n}\n.ag-theme-balham .ag-charts-format-top-level-group-item {\n  margin: 4px 0;\n}\n.ag-theme-balham .ag-charts-format-sub-level-group-container {\n  padding: 6px 6px;\n  padding-bottom: 2px;\n}\n.ag-theme-balham .ag-charts-format-sub-level-group-container > * {\n  margin-bottom: 4px;\n}\n.ag-theme-balham .ag-charts-group-container.ag-group-container-horizontal {\n  padding: 4px;\n}\n.ag-theme-balham .ag-chart-data-section,\n.ag-theme-balham .ag-chart-format-section {\n  display: -webkit-box;\n  display: flex;\n  margin: 0;\n}\n.ag-theme-balham .ag-chart-menu-panel {\n  background-color: #f5f7f7;\n  background-color: var(--ag-control-panel-background-color, #f5f7f7);\n}\n.ag-theme-balham .ag-ltr .ag-chart-menu-panel {\n  border-left: solid 1px;\n  border-left-color: #bdc3c7;\n  border-left-color: var(--ag-border-color, #bdc3c7);\n}\n\n.ag-theme-balham .ag-rtl .ag-chart-menu-panel {\n  border-right: solid 1px;\n  border-right-color: #bdc3c7;\n  border-right-color: var(--ag-border-color, #bdc3c7);\n}\n\n.ag-theme-balham .ag-date-time-list-page-title {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.ag-theme-balham .ag-date-time-list-page-column-label {\n  text-align: center;\n}\n.ag-theme-balham .ag-date-time-list-page-entry {\n  text-align: center;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper {\n  font-family: \"agGridBalham\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, white));\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper input, .ag-theme-balham .ag-checkbox-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper:focus-within, .ag-theme-balham .ag-checkbox-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper::after {\n  content: \"\\f108\";\n  color: #7f8c8d;\n  color: var(--ag-checkbox-unchecked-color, #7f8c8d);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper.ag-checked::after {\n  content: \"\\f106\";\n  color: #0091ea;\n  color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-balham .ag-checkbox-input-wrapper.ag-indeterminate::after {\n  content: \"\\f107\";\n  color: #7f8c8d;\n  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #7f8c8d));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 32px;\n  height: 16px;\n  background-color: #7f8c8d;\n  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #7f8c8d));\n  border-radius: 8px;\n  position: relative;\n  -webkit-box-flex: 0;\n          flex: none;\n  border: 1px solid;\n  border-color: #7f8c8d;\n  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #7f8c8d));\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper input {\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper:focus-within {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper.ag-checked {\n  background-color: #0091ea;\n  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));\n  border-color: #0091ea;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper::before {\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 16px;\n  width: 16px;\n  background-color: white;\n  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, white));\n  border-radius: 8px;\n  -webkit-transition: left 100ms;\n  transition: left 100ms;\n  border: 1px solid;\n  border-color: #7f8c8d;\n  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #7f8c8d)));\n}\n.ag-theme-balham .ag-toggle-button-input-wrapper.ag-checked::before {\n  left: calc(100% - 16px );\n  border-color: #0091ea;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea)));\n}\n.ag-theme-balham .ag-radio-button-input-wrapper {\n  font-family: \"agGridBalham\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, white));\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n  border-radius: 16px;\n}\n.ag-theme-balham .ag-radio-button-input-wrapper input, .ag-theme-balham .ag-radio-button-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-balham .ag-radio-button-input-wrapper:focus-within, .ag-theme-balham .ag-radio-button-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n}\n.ag-theme-balham .ag-radio-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-radio-button-input-wrapper::after {\n  content: \"\\f126\";\n  color: #7f8c8d;\n  color: var(--ag-checkbox-unchecked-color, #7f8c8d);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-balham .ag-radio-button-input-wrapper.ag-checked::after {\n  content: \"\\f127\";\n  color: #0091ea;\n  color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-balham input[class^=ag-][type=range] {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 100%;\n  background: none;\n  overflow: visible;\n}\n.ag-theme-balham input[class^=ag-][type=range]::-webkit-slider-runnable-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #bdc3c7;\n  background-color: var(--ag-border-color, #bdc3c7);\n  border-radius: 2px;\n  border-radius: 3px;\n}\n.ag-theme-balham input[class^=ag-][type=range]::-moz-range-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #bdc3c7;\n  background-color: var(--ag-border-color, #bdc3c7);\n  border-radius: 2px;\n  border-radius: 3px;\n}\n.ag-theme-balham input[class^=ag-][type=range]::-ms-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #bdc3c7;\n  background-color: var(--ag-border-color, #bdc3c7);\n  border-radius: 2px;\n  border-radius: 3px;\n  color: transparent;\n  width: calc(100% - 2px);\n}\n.ag-theme-balham input[class^=ag-][type=range]::-webkit-slider-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  border: 1px solid;\n  border-color: #7f8c8d;\n  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);\n  border-radius: 16px;\n  -webkit-transform: translateY(-6.5px);\n          transform: translateY(-6.5px);\n}\n.ag-theme-balham input[class^=ag-][type=range]::-ms-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  border: 1px solid;\n  border-color: #7f8c8d;\n  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);\n  border-radius: 16px;\n}\n.ag-theme-balham input[class^=ag-][type=range]::-moz-ag-range-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  border: 1px solid;\n  border-color: #7f8c8d;\n  border-color: var(--ag-checkbox-unchecked-color, #7f8c8d);\n  border-radius: 16px;\n}\n.ag-theme-balham input[class^=ag-][type=range]:focus {\n  outline: none;\n}\n.ag-theme-balham input[class^=ag-][type=range]:focus::-webkit-slider-thumb {\n  -webkit-box-shadow: 0 0 2px 1px #719ECE;\n          box-shadow: 0 0 2px 1px #719ECE;\n  border-color: #0091ea;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham input[class^=ag-][type=range]:focus::-ms-thumb {\n  box-shadow: 0 0 2px 1px #719ECE;\n  border-color: #0091ea;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {\n  box-shadow: 0 0 2px 1px #719ECE;\n  border-color: #0091ea;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-balham-active-color, #0091ea));\n}\n.ag-theme-balham input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {\n  background-color: #719ECE;\n  background-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham input[class^=ag-][type=range]:active::-moz-ag-range-track {\n  background-color: #719ECE;\n  background-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham input[class^=ag-][type=range]:active::-ms-track {\n  background-color: #719ECE;\n  background-color: var(--ag-input-focus-border-color, #719ECE);\n}\n.ag-theme-balham input[class^=ag-][type=range]:disabled {\n  opacity: 0.5;\n}\n.ag-theme-balham .ag-filter-toolpanel-header,\n.ag-theme-balham .ag-filter-toolpanel-search,\n.ag-theme-balham .ag-status-bar,\n.ag-theme-balham .ag-header-row,\n.ag-theme-balham .ag-multi-filter-group-title-bar {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n}\n.ag-theme-balham .ag-ltr input[class^=ag-]:not([type]),\n.ag-theme-balham .ag-ltr input[class^=ag-][type=text],\n.ag-theme-balham .ag-ltr input[class^=ag-][type=number],\n.ag-theme-balham .ag-ltr input[class^=ag-][type=tel],\n.ag-theme-balham .ag-ltr input[class^=ag-][type=date],\n.ag-theme-balham .ag-ltr input[class^=ag-][type=datetime-local],\n.ag-theme-balham .ag-ltr textarea[class^=ag-] {\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-rtl input[class^=ag-]:not([type]),\n.ag-theme-balham .ag-rtl input[class^=ag-][type=text],\n.ag-theme-balham .ag-rtl input[class^=ag-][type=number],\n.ag-theme-balham .ag-rtl input[class^=ag-][type=tel],\n.ag-theme-balham .ag-rtl input[class^=ag-][type=date],\n.ag-theme-balham .ag-rtl input[class^=ag-][type=datetime-local],\n.ag-theme-balham .ag-rtl textarea[class^=ag-] {\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-column-drop-vertical-empty-message, .ag-theme-balham .ag-status-bar {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-balham .ag-dnd-ghost {\n  font-weight: 600;\n}\n.ag-theme-balham .ag-tab {\n  border: 1px solid transparent;\n  padding: 4px 8px;\n  margin: 4px;\n  margin-bottom: -1px;\n}\n.ag-theme-balham .ag-tab-selected {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  border-bottom-color: transparent;\n}\n.ag-theme-balham .ag-tabs-header {\n  border-bottom: 1px solid;\n  border-bottom-color: #bdc3c7;\n  border-bottom-color: var(--ag-border-color, #bdc3c7);\n}\n.ag-theme-balham .ag-column-drop-cell {\n  height: 24px;\n}\n.ag-theme-balham .ag-column-drop-vertical-title {\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n}\n.ag-theme-balham .ag-column-drop-vertical-cell {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.ag-theme-balham .ag-column-drop-vertical-cell-text {\n  margin-left: 8px;\n}\n.ag-theme-balham .ag-column-drop-vertical-icon {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-balham .ag-ltr .ag-column-drop-vertical-empty-message {\n  padding-left: 24px;\n  padding-right: 4px;\n}\n\n.ag-theme-balham .ag-rtl .ag-column-drop-vertical-empty-message {\n  padding-right: 24px;\n  padding-left: 4px;\n}\n\n.ag-theme-balham .ag-column-drop-horizontal {\n  height: 32px;\n}\n.ag-theme-balham .ag-column-drop-empty {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-balham .ag-column-drop-horizontal-cell-text {\n  margin-left: 8px;\n}\n.ag-theme-balham .ag-column-drop-vertical {\n  padding-top: 8px;\n}\n.ag-theme-balham .ag-menu-header {\n  background-color: #f5f7f7;\n  background-color: var(--ag-header-background-color, #f5f7f7);\n}\n.ag-theme-balham .ag-overlay-loading-center {\n  background-color: white;\n  background-color: var(--ag-background-color, white);\n  border: 1px solid;\n  border-color: #bdc3c7;\n  border-color: var(--ag-border-color, #bdc3c7);\n  color: #000;\n  color: var(--ag-foreground-color, #000);\n  padding: 16px;\n}\n.ag-theme-balham .ag-tooltip {\n  border: none;\n  background-color: #cbd0d3;\n}\n.ag-theme-balham .ag-panel-title-bar-button-icon {\n  font-size: 20px;\n}\n.ag-theme-balham .ag-chart-data-section,\n.ag-theme-balham .ag-chart-format-section {\n  padding-bottom: 2px;\n}\n.ag-theme-balham .ag-group-toolbar {\n  background-color: rgba(226, 233, 235, 0.5);\n  background-color: var(--ag-subheader-toolbar-background-color, rgba(226, 233, 235, 0.5));\n}\n.ag-theme-balham .ag-chart-tab {\n  padding-top: 2px;\n}\n.ag-theme-balham .ag-charts-format-sub-level-group-item {\n  margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
